



import React, { useEffect, useState, useRef, useCallback, useMemo, useContext } from "react";
import { MatchRankConfig } from "./type_Drag";
import { min } from "lodash";
import { activityUpdate, createGamePlayHistory } from "utils/gameApplication/gameActivityService";
import { getAverageScore } from "utils/gameApplication/gamePlayService";
import AOS from "aos";
import { ScoreContext } from "../GamePreview";
import { updateDragForNowBlock, updateDragForNowBlockcategory } from "../common";




/* ─── Audio context singleton ─── */
let audioCtx: AudioContext | null = null;
let audioUnlocked = false;

function unlockAudio() {
  if (audioUnlocked) return;
  try {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    audioCtx
      .resume()
      .then(() => {
        const osc = audioCtx!.createOscillator();
        const gain = audioCtx!.createGain();
        gain.gain.value = 0.0001;
        osc.connect(gain);
        gain.connect(audioCtx!.destination);
        osc.start();
        osc.stop(audioCtx!.currentTime + 0.01);
        audioUnlocked = true;
      })
      .catch(() => {
        audioUnlocked = true;
      });
  } catch (e) {
    /* audio is optional */
  }
}

function playTone(kind: string) {
  if (!audioUnlocked || !audioCtx) return;
  if (audioCtx.state === "suspended") audioCtx.resume();
  try {
    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.connect(gain);
    gain.connect(audioCtx.destination);

    if (kind === "correct") {
      osc.frequency.setValueAtTime(523.25, now);
      osc.frequency.setValueAtTime(659.25, now + 0.1);
      gain.gain.setValueAtTime(0.15, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
      osc.start(now);
      osc.stop(now + 0.3);
    } else if (kind === "wrong") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(200, now);
      osc.frequency.setValueAtTime(160, now + 0.1);
      gain.gain.setValueAtTime(0.08, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);
      osc.start(now);
      osc.stop(now + 0.15);
    } else if (kind === "drop") {
      osc.frequency.setValueAtTime(440, now);
      gain.gain.setValueAtTime(0.08, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.1);
      osc.start(now);
      osc.stop(now + 0.1);
    } else if (kind === "select") {
      osc.frequency.setValueAtTime(600, now);
      gain.gain.setValueAtTime(0.1, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);
      osc.start(now);
      osc.stop(now + 0.15);
    } else if (kind === "fanfare") {
      const notes = [523.25, 659.25, 783.99, 1046.5];
      notes.forEach((freq, i) => {
        const o = audioCtx!.createOscillator();
        const g = audioCtx!.createGain();
        o.connect(g);
        g.connect(audioCtx!.destination);
        o.frequency.setValueAtTime(freq, now + i * 0.15);
        g.gain.setValueAtTime(0.12, now + i * 0.15);
        g.gain.exponentialRampToValueAtTime(0.001, now + i * 0.15 + 0.25);
        o.start(now + i * 0.15);
        o.stop(now + i * 0.15 + 0.3);
      });
      return;
    } else if (kind === "complete") {
      osc.frequency.setValueAtTime(880, now);
      gain.gain.setValueAtTime(0.1, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
      osc.start(now);
      osc.stop(now + 0.5);
    }
  } catch (e) {
    /* audio optional */
  }
}

/* ─── Helpers ─── */
function shuffleArray<T>(array: T[]): T[] {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/* ─── Default Config ─── */
const DEFAULT_CONFIG: MatchRankConfig = {
  version: 1,
  gameMode: "category",
  title: "💡 Mini-Game: Category Match",
  subtitle: "Drag the correct category onto each statement!",
  elements: [{ id: "categoryName1", categories: ["Option A", "Option B", "Option C"] }],
  rounds: [
    { id: "1", text: "Example statement 1", correct: "Option A", why: "This is the hint for statement 1." },
    { id: "2", text: "Example statement 2", correct: "Option B", why: "This is the hint for statement 2." },
  ],
  settings: {
    pointsPerCorrect: 100,
    timerEnabled: false,
    timePerRound: 30,
    allowReplay: true,
    feedbackMode: "immediate",
    allowReuseCategories: false,
    streakMessages: { streak2: "👍 Nice!", streak3: "✨ Wow!", streak4: "🔥 On Fire!", streak5: "💯 PERFECT RUN!" },
    congratulatoryMessages: [
      { minPercent: 0, maxPercent: 33, message: "Keep practicing! Review the hints to improve." },
      { minPercent: 34, maxPercent: 66, message: "Good effort! You're getting the hang of it." },
      { minPercent: 67, maxPercent: 100, message: "Excellent work! You've mastered this challenge." },
    ],
  },
};

/* ═══════════════════════════════════════════════
   TOP-LEVEL COMPONENT
   ═══════════════════════════════════════════════ */
const MatchRankPreview = ({
   AssignId,
  setGameProgressData,
    gameProgressData,
  seconds,
  data, gameInfo, Activitydata,type, setActivitydata, formData, learnerPlayList, 
   learner_game_play_id,setProfile, setLearnerPlayingDetails, profile, questState, onCompleted,isAudioPaused, isDragForNowCompleted,
  setIsDragForNowCompleted, }: {
    AssignId?:any;
    gameProgressData?:any;
  setGameProgressData?:any;
    data?: any;
    seconds?:any;
          isDragForNowCompleted?:any;
  setIsDragForNowCompleted?:any;
    gameInfo?: any;
     learner_game_play_id?:any;
 type?: any;
    learnerPlayList?: any;
    formData?: any;
    setActivitydata?: any;
    Activitydata?: any;
    setProfile?: any;
    questState?: any;
    profile?: any
    setLearnerPlayingDetails?: any;
    onCompleted?: () => void;
    isAudioPaused?:boolean;

  } = {}) => {
  const [config, setConfig] = useState<MatchRankConfig | null>(null);
  const [miniGameScore, setMiniGameScore] = useState(0);
  const [prevAvgScore, setPrevAvgScore] = useState<number>(0);
  const [prevMiniGameBest, setPrevMiniGameBest] = useState(0);
  const [bestScore, setBestScore] = useState(0);
  const [currentGameScore, setCurrentGameScore] = useState(0); 
  const [averageScore, setaverageScore] = useState(0);
  const [histActivityId, setHistActivityId] = useState<string | null>(null);

  useEffect(() => {
  const initActivity = async () => {
    try {
             let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        galTimeSpent: seconds,
        gameId: learner_game_play_id
      };
      const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata);

      const result = await activityUpdate(datas, actId1);

      // const galId = result?.updatedData?.galId;
      const galId = result?.updatedData?.galId;
      const oldScore = result?.updatedData?.galAverageScore || 0;

      if (galId) {
        setHistActivityId(galId);
        // setPrevAvgScore(Number(oldScore)); // ✅ save previous
        const previous = Number(oldScore) || 0;

        setPrevAvgScore(previous);
        setBestScore(previous); // store best

      }
      if (galId) {
        setHistActivityId(galId); // ✅ store for later update
      }
    } catch (err) {
      console.error("Activity init failed:", err);
    }
  };
   initActivity();
}, []);
  useEffect(() => {
    try {
      const hash = window.location.hash.slice(1);
      if (hash) {
        const decoded = JSON.parse(decodeURIComponent(atob(hash)));
        setConfig(decoded);
        return;
      }
      const saved = localStorage.getItem("match-rank-editor-config");
      if (saved) {
        setConfig(JSON.parse(saved));
      } else {
        setConfig(DEFAULT_CONFIG);
      }
    } catch (e) {
      console.error("Failed to load game config:", e);
      setConfig(DEFAULT_CONFIG);
    }
  }, []);

  // Audio unlock via gestures (Safari)
  useEffect(() => {
    const handler = () => {
      unlockAudio();
    };
    window.addEventListener("pointerdown", handler);
    window.addEventListener("touchstart", handler);
    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("pointerdown", handler);
      window.removeEventListener("touchstart", handler);
      window.removeEventListener("click", handler);
    };
  }, []);
  const currentBlockMiniGame = useMemo(() => {

    if (!gameInfo?.ChooseMiniGame || !data?.blockId) return null;

    return gameInfo.ChooseMiniGame.find(
      (game: any) =>
        String(game.miniblockId) === String(data.blockId)
    );
  }, [gameInfo, data]);
  const buildGameConfigFromBlock = (miniGame: any): MatchRankConfig => {
    if (!miniGame?.roundLogic) return DEFAULT_CONFIG;
    if (miniGame?.GameMode === "CategoryMatching") {
      // const roundObj = JSON.parse(miniGame.roundLogic);

      let roundObj: any;
      
      try {
        if (typeof miniGame.roundLogic === "string") {
          roundObj = JSON.parse(miniGame.roundLogic);
        } else {
          roundObj = miniGame.roundLogic; // already an object
        }
      } catch (e) {
        console.error("Invalid roundLogic:", miniGame.roundLogic);
        // return DEFAULT_GAME_CONFIG;
      }
      const categoryRounds = roundObj?.categoryRounds;
      const elements = roundObj ? Object.entries(categoryRounds).map(
        ([key, round]: any, index: number) => ({
          id: key, // ✅ required string id
          categories: Object.values(round?.categories || {})
        })
      ) : [];
      const categoryList = elements?.flatMap(
        (round: any) => round?.categories || []
      ) || [];
 
    
      const rounds = categoryRounds
        ? Object.entries(categoryRounds).flatMap(([key, round]: any) => {
          const statements = round?.statements || {};

          // find how many statements exist
          const statementKeys = Object.keys(statements).filter(k =>
            k.startsWith("statementText")
          );

          return statementKeys.map((key, index) => {
            const statementIndex = key.replace("statementText", "");

            return {
              id: `round-${index + 1}`,
              text: statements[`statementText${statementIndex}`] || "",
              correct: statements[`selectedCategory${statementIndex}`] || "",
              why: statements[`feedback${statementIndex}`] || "",
            };
          });
        })
        : [
          {
            id: "round-1",
            text: "text",
            correct: "cat1",
            why: "feedback",
          },
        ];
   
      return {
        version: 1,
        gameMode: miniGame?.GameMode === "CategoryMatching" ? "category" : "ranking",
        title: miniGame?.MiniTitle || "💡 Mini-Game: Category Match",
        subtitle: miniGame?.WehaveChoose || "Drag the correct category onto each statement!",
        elements: categoryList,
        rounds,
        settings: {
          pointsPerCorrect: miniGame.PointsPerCorrectScore || 0,
          timerEnabled: miniGame.timerEnabled || false,
          timePerRound: miniGame.Timerlimit || 30,
          allowReplay: miniGame?.ShowReplay ? true : false,
          feedbackMode: "immediate",
          allowReuseCategories: false,
          streakMessages: { streak2: miniGame?.Streak2message || "👍 Nice!", streak3: miniGame?.Streak3message || "✨ Wow!", streak4: miniGame?.Streak4message || "🔥 On Fire!", streak5: miniGame?.Streak5message || "💯 PERFECT RUN!" },
          congratulatoryMessages: [
            { minPercent: miniGame?.Minlowscore || 0, maxPercent: miniGame?.Maxlowscore || 0, message: miniGame?.LowScoreMessage || "Keep practicing! Review the hints to improve." },
            { minPercent: miniGame?.Minmediumscore || 0, maxPercent: miniGame?.Maxmediumscore || 0, message: miniGame?.MediumScoreMessage || "Good effort! You're getting the hang of it." },
            { minPercent: miniGame?.Minhighscore || 0, maxPercent: miniGame?.Maxhighscore || 0, message: miniGame?.highScoreMessage || "Excellent work! You've mastered this challenge." },
          ],
        },
      };
    }
    // else {
    //   const roundObj = JSON.parse(miniGame.roundLogic);
    //   const rankingRounds = roundObj?.rankingRounds;

    //   const rounds = rankingRounds ? Object.entries(rankingRounds).map(
    //     ([key, round]: any, index: number) => {
    //       const statements = round?.statements || {};
    //       const statementIndex = 1; // since your data has statementText1
    //       return {
    //         id: `round-${index + 1}`,
    //         text: statements[`statementText${statementIndex}`] || "",
    //         correct: statements[`selectedCategory${statementIndex}`] || "",
    //         correctRank: statements[`selectedCategory${statementIndex}`] || "",
    //         why: statements[`feedback${statementIndex}`] || "",
    //       };
    //     }
    //   ) : [
    //     {
    //       "id": "round-1",
    //       "text": "text",
    //       "correct": "cat1",
    //       "correctRank": "cat1",
    //       "why": "feedback"
    //     }
    //   ];
    //   return {
    //     version: 1,
    //     gameMode: miniGame?.GameMode === "CategoryMatching" ? "category" : "ranking",
    //     title: miniGame?.MiniTitle || "💡 Mini-Game: Category Match",
    //     subtitle: miniGame?.WehaveChoose || "Drag the correct category onto each statement!",
    //     elements: [],
    //     rounds,
    //     settings: {
    //       pointsPerCorrect: miniGame.PointsPerCorrectScore || 0,
    //       timerEnabled: miniGame.timerEnabled || false,
    //       timePerRound: miniGame.Timerlimit || 30,
    //       allowReplay: miniGame?.ShowReplay ? true : false,
    //       feedbackMode: "immediate",
    //       allowReuseCategories: false,
    //       streakMessages: { streak2: miniGame?.Streak2message || "👍 Nice!", streak3: miniGame?.Streak3message || "✨ Wow!", streak4: miniGame?.Streak4message || "🔥 On Fire!", streak5: miniGame?.Streak5message || "💯 PERFECT RUN!" },
    //       congratulatoryMessages: [
    //         { minPercent: miniGame?.Minlowscore || 0, maxPercent: miniGame?.Maxlowscore || 0, message: miniGame?.LowScoreMessage || "Keep practicing! Review the hints to improve." },
    //         { minPercent: miniGame?.Minmediumscore || 0, maxPercent: miniGame?.Maxmediumscore || 0, message: miniGame?.MediumScoreMessage || "Good effort! You're getting the hang of it." },
    //         { minPercent: miniGame?.Minhighscore || 0, maxPercent: miniGame?.Maxhighscore || 0, message: miniGame?.highScoreMessage || "Excellent work! You've mastered this challenge." },
    //       ],
    //     },
    //   };
    // }
    else {
  let roundObj: any;

  try {
    if (typeof miniGame.roundLogic === "string") {
      roundObj = JSON.parse(miniGame.roundLogic);
    } else {
      roundObj = miniGame.roundLogic;
    }
  } catch (e) {
    console.error("Invalid roundLogic:", miniGame.roundLogic);
    return DEFAULT_CONFIG;
  }

  const rankingRounds = roundObj?.rankingRounds;

        const rounds = rankingRounds
        ? Object.entries(rankingRounds).flatMap(([key, round]: any) => {
          const statements = round?.statements || {};

          const correctRankCount = Object.keys(statements)
            .filter(k => k.startsWith("correctAnswer"))
            .filter(k => statements[k] !== "")
            .length;
          // find how many statements exist
          const statementKeys = Object.keys(statements).filter(k =>
            k.startsWith("statementText")
          );

          return statementKeys.map((key, index) => {
            const statementIndex = key.replace("statementText", "");

            return {
              id: `round-${index + 1}`,
              text: statements[`statementText${statementIndex}`] || "",
              correct: statements[`selectedCategory${statementIndex}`] || "",
              correctRank: statements[`correctAnswer${statementIndex}`] || "",
              why: statements[`feedback${statementIndex}`] || "",
              correctRankCount
            };
          });
        })
        : [
          {
            id: "round-1",
            text: "text",
            correct: "cat1",
              correctRank: "cat1",
            why: "feedback",
            correctRankCount: 0
          },
        ];

  return {
    version: 1,
    gameMode: "ranking",
    title: miniGame?.MiniTitle || "💡 Mini-Game: Ranking",
    subtitle: miniGame?.WehaveChoose || "Arrange in correct order!",
    elements: [],
    rounds,
    settings: {
      pointsPerCorrect: miniGame.PointsPerCorrectScore || 0,
      timerEnabled: miniGame.timerEnabled || false,
      timePerRound: miniGame.Timerlimit || 30,
      allowReplay: !!miniGame?.ShowReplay,
      feedbackMode: "immediate",
      allowReuseCategories: false,
      streakMessages: {
        streak2: miniGame?.Streak2message || "👍 Nice!",
        streak3: miniGame?.Streak3message || "✨ Wow!",
        streak4: miniGame?.Streak4message || "🔥 On Fire!",
        streak5: miniGame?.Streak5message || "💯 PERFECT RUN!",
      },
      congratulatoryMessages: [
        {
          minPercent: miniGame?.Minlowscore || 0,
          maxPercent: miniGame?.Maxlowscore || 0,
          message:
            miniGame?.LowScoreMessage ||
            "Keep practicing! Review the hints to improve.",
        },
        {
          minPercent: miniGame?.Minmediumscore || 0,
          maxPercent: miniGame?.Maxmediumscore || 0,
          message:
            miniGame?.MediumScoreMessage ||
            "Good effort! You're getting the hang of it.",
        },
        {
          minPercent: miniGame?.Minhighscore || 0,
          maxPercent: miniGame?.Maxhighscore || 0,
          message:
            miniGame?.highScoreMessage ||
            "Excellent work! You've mastered this challenge.",
        },
      ],
    },
  };
}
  };

  useEffect(() => {
    if (!currentBlockMiniGame) {
      console.warn("No mini-game for block:", data?.blockId);
      return;
    }

    const config = buildGameConfigFromBlock(currentBlockMiniGame);
    setConfig(config);

  }, [currentBlockMiniGame]);

  const saveGameScoreHistory = async (score: any) => {
    try {
      const histdata = {
        histGameId: gameInfo.gameData.gameId,
        histQuestNo: profile.currentQuest,
        histBlockId: data.blockSecondaryId,
        // histType: type,
        histScore: score,
        learnerid: learnerPlayList.playerId,
        histType: config.gameMode
      };
      const stringhistdata = JSON.stringify(histdata)

      const historyResult = await createGamePlayHistory(stringhistdata);

   
    } catch (error) {
      console.error("Error saving game score history:", error);
    }
  };

  const getMinigameAverageScore = async () => {
    try {
      const histdata = {
        gameId: gameInfo.gameData.gameId,
        questNo: profile.currentQuest,
        blockSecondaryId: data.blockSecondaryId,
        type: config.gameMode,
        learnerid: learnerPlayList.playerId,
      };
      const stringhistdata = JSON.stringify(histdata)
      const historyResult = await getAverageScore(stringhistdata);
      if (historyResult?.status === "Success") {
         const score = historyResult?.maxScore || 0;

        setaverageScore(score); // update state (for UI)
        return score;
      }
       return 0;

    } catch (error) {
      console.error("Error saving game score history:", error);
       return 0;
    }
  };


useEffect(() => {
  AOS.refresh();
}, []);
 const handleMiniGameComplete = async (earned: number, max: number) => {

    setCurrentGameScore(earned);
    if (earned > averageScore) {
      await saveGameScoreHistory(earned)
    }
    const latestAverageScore = await getMinigameAverageScore();
    setIsDragForNowCompleted(true)


    const gameId = String(learner_game_play_id);
    let scenarioId = 1;    // scenario id

    // let scenarioScores = JSON.parse(localStorage.getItem("scenarioScores")) || {};

    // // create gameId if not exist
    // if (!scenarioScores[gameId]) {
    //   scenarioScores[gameId] = {};
    // }
    const getaveragescore = averageScore;

    // // get existing score
    // let existingScore = scenarioScores[gameId][scenarioId] || 0;
   
    // // FIRST TIME PLAY
    // if (existingScore === 0) {

    //   scenarioScores[gameId][scenarioId] = earned;

    // }
    // // SECOND TIME OR MORE
    // else if (earned > averageScore) {

    //   const difference = earned - averageScore;

    //   scenarioScores[gameId][scenarioId] = existingScore + difference;

    // }
    // // save
    // localStorage.setItem("scenarioScores", JSON.stringify(scenarioScores));
    let getscenarioScores = gameProgressData?.scenarioScores || {};

    const questNo = data?.blockQuestNo;
    const scenarioName =
      typeof data.blockScenario === 'string'
        ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
        : data.blockScenario;
    // const scenarioName = data?.blockScenario;

    if (!getscenarioScores[questNo]) {
      getscenarioScores[questNo] = {};
    }

    let getexistingScore =
      getscenarioScores[questNo][scenarioName] || 0;


    // FIRST TIME PLAY
    if (getexistingScore === 0) {
      getscenarioScores[questNo][scenarioName] = earned;
    }
    // SECOND TIME OR MORE
    else if (earned > averageScore) {
      const difference = earned - averageScore;

      getscenarioScores[questNo][scenarioName] =
        getexistingScore + difference;
    }

    setGameProgressData((prev: any) => ({
      ...prev,
      scenarioScores: getscenarioScores,
    }));
    // setMiniGameScore(earned);
    const finalScore = Math.max(prevAvgScore, getaveragescore);

    setMiniGameScore(finalScore);
    setBestScore(finalScore);
    // if (!histActivityId) {
    //   console.warn("No histActivityId found");
    //   return;
    // }
    // setTimeout(() => {
      onCompleted?.();
    // }, 300);
    try {
      let finalScore = prevAvgScore;

      // only add improvement
      if (earned > prevMiniGameBest) {
        const difference = earned - prevMiniGameBest;

        finalScore = prevAvgScore + difference;

        // update best mini-game score
        setPrevMiniGameBest(earned);
      }
      const histData = {
        blockname: 'DragForNow',
        galAverageScore: finalScore,
        galBlockId: data?.blockSecondaryId,
         gameId: learner_game_play_id,
         galblockleft : data?.blockSecondaryId,
         galTimeSpent: seconds,
      };


      let eranedscoremin = earned;
      await activityUpdate(JSON.stringify(histData), histActivityId);
      setPrevAvgScore(finalScore);
      setBestScore(finalScore);
      const seqId = data?.blockPrimarySequence;
      const scoresearned = eranedscoremin;
      const questNo = parseInt(seqId.split(".")[0]);

      // Determine replay/first try mode
      const isReplay =
        Object.keys(questState).length > 0 &&
        questState[profile?.currentQuest] === "replayallowed";
      const scenarioIds =
        typeof data.blockScenario === 'string'
          ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
          : data.blockScenario;
      // ✅ Update score or replayScore safely
      setProfile((prev: any) => {
        const targetList = isReplay ? prev.replayScore : prev.score;
        const idx = targetList.findIndex((i: any) => i.seqId === seqId);
        const updatedList = [...targetList];
        const numericScore = Number(scoresearned || 0);
      
        if (idx !== -1) {
          // Update existing score safely
          updatedList[idx] = {
            ...updatedList[idx],
            // score: numericScore,
            score: latestAverageScore,
            choosedoption: "",
            quest: questNo,
            scoreEarnedDate: "",
            scenarioId: scenarioIds,
          };
        } else {
          // Add new score entry
          updatedList.push({
            seqId,
            // score: numericScore,
            score: latestAverageScore,
            choosedoption: "",
            quest: questNo,
            scoreEarnedDate: "",
            scenarioId: scenarioIds,
          });
          // ✅ Only push first try to learnerPlayingDetails
          // if (!isReplay) {
          //   setLearnerPlayingDetails((prevPlay: any) => ({
          //     ...prevPlay,
          //     firstTryScore: [
          //       ...prevPlay.firstTryScore,
          //       {
          //         seqId, quest: questNo,
          //         score: latestAverageScore,
          //       },
          //     ],
          //   }));
          // }
          if (!isReplay) {
  setLearnerPlayingDetails((prevPlay: any) => {
    const alreadyExists = prevPlay.firstTryScore.some(
      (item: any) => item.seqId === seqId
    );
    if (alreadyExists) return prevPlay;

    return {
      ...prevPlay,
      firstTryScore: [
        ...prevPlay.firstTryScore,
        { seqId, quest: questNo, score: latestAverageScore },
      ],
    };
  });
}
        }
        return {
          ...prev,
          [isReplay ? "replayScore" : "score"]: updatedList,
        };
      });

    } catch (err) {
      console.error("Score update failed:", err);
    }
  };

  if (!config) {
    return (
      <div className="min-h-screen bg-[#05060a] text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mx-auto mb-4"></div>
          <p className="text-white/70">Loading game...</p>
        </div>
      </div>
    );
  }

  return config.gameMode === "ranking" ? <RankingGame config={config} averageScore={averageScore} onComplete={handleMiniGameComplete} bestScore={bestScore} currentGameScore={currentGameScore} isTimerPaused={isAudioPaused} data={data} /> : <CategoryMatchGame config={config} onComplete={handleMiniGameComplete} bestScore={bestScore} currentGameScore={currentGameScore} isTimerPaused={isAudioPaused} averageScore={averageScore} data={data} />;
};

/* ═══════════════════════════════════════════════
   CATEGORY MATCH GAME
   ═══════════════════════════════════════════════ */
interface GameProps {
  config: MatchRankConfig;
  onComplete: (score: number, max: number) => void; // ✅
    onCompleted?: () => void;
  bestScore: number;
  currentGameScore:any;
    isTimerPaused?: boolean;
      averageScore: number;
      data:any;
  
}

interface CardItem {
  id: number;
  goal: string;
  answer: string;
  hint: string;
  feedback: string;
}

const CategoryMatchGame: React.FC<GameProps> = ({ config,averageScore, onComplete, bestScore,currentGameScore,  onCompleted,isTimerPaused ,data}) => {
  const cards: CardItem[] = config.rounds.map((r:any, i:any) => ({
    id: parseInt(r.id) || i + 1,
    goal: r.text,
    answer: r.correct,
    hint: r.why || "",
    feedback: r.feedback || "",
  }));
  const maxPoints = cards.length * config.settings.pointsPerCorrect;

  const feedbackMode = config.settings.feedbackMode || "immediate";
  const allowReuse = config.settings.allowReuseCategories || false;
  const [attempt, setAttempt] = useState(1);
  const {setlearnerActivityrec,deviceInfo} = useContext(ScoreContext);
  const [shuffledCards, setShuffledCards] = useState(() => shuffleArray(cards));
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [correctCards, setCorrectCards] = useState<Set<number>>(new Set());
  const [streak, setStreak] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(config.settings.timePerRound);
  const [showTimeup, setShowTimeup] = useState(false);
  const [lockedToast, setLockedToast] = useState(false);
  const [streakPopup, setStreakPopup] = useState<{ text: string; cls: string } | null>(null);
  const [dragOverId, setDragOverId] = useState<number | null>(null);
  const [draggingChip, setDraggingChip] = useState<string | null>(null);
  const [lastAnswer, setLastAnswer] = useState<"correct" | "incorrect" | "timeout" | null>(null);
  const [slotInId, setSlotInId] = useState<number | null>(null);
  const [showScroll, setShowScroll] = useState(false);
  const [wrongRows, setWrongRows] = useState<Set<number>>(new Set());
  const [shownHints, setShownHints] = useState<Record<number, { text: string; cls: string }>>({});
  const [showFeedback, setShowFeedback] = useState(false);
  const [showWipe, setShowWipe] = useState(false)
  const [currentRound, setCurrentRound] = useState(0);
  const cardRef = useRef<HTMLDivElement>(null);
  const chatRef = useRef<HTMLDivElement>(null);
  const particleRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const lockedToastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const replayCountRef = useRef(0);
  const originalScoreRef = useRef<number | null>(null);
  const highestScoreRef = useRef(0);
  const statementCardRef = useRef<HTMLDivElement>(null);
  const lockedRef = useRef(false);
  const answeredCount = Object.keys(answers).length;
  const circumference = 2 * Math.PI * 18;
  const timerOffset = circumference * (1 - timeLeft / config.settings.timePerRound);
  const timerState = timeLeft <= 5 ? "danger" : timeLeft <= 10 ? "warning" : "";
  const currentPoints = Number(score);
  // Timer
  useEffect(() => {
    if (!config.settings.timerEnabled || gameComplete || isSubmitted) return;
    setTimeLeft(config.settings.timePerRound);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev:any) => {
        if (prev <= 1) {
          if (timerRef.current) clearInterval(timerRef.current);
          setShowTimeup(true);
          playTone("wrong");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [gameComplete, isSubmitted]);
useEffect(() => {
  if (gameComplete) {
    onComplete(currentPoints, maxPoints);
  }
}, [gameComplete]);
  // Scroll indicator
  useEffect(() => {
    const el = chatRef.current;
    if (!el) return;
    const check = () => {
      const scrollable = el.scrollHeight > el.clientHeight;
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      setShowScroll(scrollable && !atBottom);
    };
    check();
    el.addEventListener("scroll", check);
    return () => el.removeEventListener("scroll", check);
  }, [shuffledCards, answers]);

  const showLockedToastFn = useCallback(() => {
    setLockedToast(true);
    if (lockedToastTimer.current) clearTimeout(lockedToastTimer.current);
    lockedToastTimer.current = setTimeout(() => setLockedToast(false), 3000);
  }, []);

  const showStreakPopup = useCallback(
    (count: number) => {
      if (count < 2) return;
      const msgs = config.settings.streakMessages;
      let text: string, cls: string;
      if (count >= 5) {
        text = msgs.streak5 || "💯 PERFECT RUN!";
        cls = "perfect";
      } else if (count >= 4) {
        text = msgs.streak4 || "🔥 On Fire!";
        cls = "perfect";
      } else if (count >= 3) {
        text = msgs.streak3 || "✨ Wow!";
        cls = "wow";
      } else {
        text = msgs.streak2 || "👍 Nice!";
        cls = "nice";
      }
      setStreakPopup({ text, cls });
      setTimeout(() => setStreakPopup(null), 800);
    },
    [config.settings.streakMessages],
  );

  const createParticle = useCallback((x: number, y: number) => {
    if (!particleRef.current) return;
    const p = document.createElement("div");
    p.className = "particle";
    p.style.left = x + "px";
    p.style.top = y + "px";
    const colors = ["rgba(54,231,255,.6)", "rgba(180,107,255,.6)"];
    p.style.background = colors[Math.floor(Math.random() * colors.length)];
    p.style.boxShadow = "0 0 6px " + p.style.background;
    particleRef.current.appendChild(p);
    setTimeout(() => p.remove(), 600);
  }, []);

  useEffect(() => {
    const handler = (e: DragEvent) => {
      if (draggingChip) createParticle(e.clientX, e.clientY);
    };
    document.addEventListener("dragover", handler);
    return () => document.removeEventListener("dragover", handler);
  }, [draggingChip, createParticle]);
  const handleContinue = () => {
    playTone("tap");
    setShowFeedback(false);
          const earned = score;
      const max = maxPoints;
          
   setlearnerActivityrec((prev: any) =>
        updateDragForNowBlockcategory(
          prev,
          {
            blockId: data.blockId,
            attempt: attempt,
            finalscoreearned: score
          },
          deviceInfo
        )
      );
    if (currentRound >= config.rounds.length - 1) {
      setGameComplete(true);


      // onComplete(earned, max); // ✅ Send score up
    } else {
      setShowWipe(true);
      playTone("whoosh");
      setTimeout(() => {
        // Reset statement card before advancing round
        const el = statementCardRef.current;
        if (el) {
          el.classList.remove("swipe-left", "swipe-right", "enter-from-left", "enter-from-right");
          el.style.cssText = "";
        }
        setCurrentRound((prev) => prev + 1);
        setLockedToast(false);
        setShowFeedback(false);
        // setAnswers(null);
        setAnswers({}); 
        setShowWipe(false);
      }, 500);
    }
  };


  const getCongratulatoryMessage = useCallback(
    (numCorrect: number, total: number) => {
      const percent = Math.round((numCorrect / total) * 100);
      const sorted = [...config.settings.congratulatoryMessages]
        .filter((m) => m.message?.trim())
        .sort((a, b) => b.minPercent - a.minPercent);
      for (const msg of sorted) {
        if (percent >= msg.minPercent && percent <= msg.maxPercent) return msg.message;
      }
      if (sorted.length > 0) {
        for (const msg of sorted) {
          if (percent <= msg.maxPercent) return msg.message;
        }
      }
      return "";
    },
    [config.settings.congratulatoryMessages],
  );

  const handleDrop = useCallback(
    (cardId: number, element: string) => {
      if (isSubmitted) {
        showLockedToastFn();
        return;
      }

      const card = shuffledCards.find((c) => c.id === cardId);
      if (!card) return;

      const newAnswers = { ...answers };
      const newCorrect = new Set(correctCards);
      const newWrong = new Set(wrongRows);
      const newHints = { ...shownHints };

      // If not allowing reuse, remove from previous
      if (!allowReuse) {
        const prevId = Object.keys(newAnswers).find((id) => newAnswers[parseInt(id)] === element);
        if (prevId && parseInt(prevId) !== cardId) {
          const pid = parseInt(prevId);
          delete newAnswers[pid];
          newCorrect.delete(pid);
          newWrong.delete(pid);
          delete newHints[pid];
        }
      }

      newAnswers[cardId] = element;

      if (feedbackMode === "immediate") {
        newWrong.delete(cardId);
        if (element === card.answer) {
          newCorrect.add(cardId);
          const newStreak = streak + 1;
          setStreak(newStreak);
          playTone("correct");
          showStreakPopup(newStreak);
          if (card.feedback) {
            newHints[cardId] = { text: "✓ " + card.feedback, cls: "hint correct" };
          } else {
            delete newHints[cardId];
          }
        } else {
          newCorrect.delete(cardId);
          newWrong.add(cardId);
          setStreak(0);
          playTone("wrong");
          setTimeout(
            () =>
              setWrongRows((prev) => {
                const s = new Set(prev);
                s.delete(cardId);
                return s;
              }),
            400,
          );
          if (card.hint?.trim()) {
            newHints[cardId] = { text: "💡 " + card.hint, cls: "hint wrong" };
          } else {
            delete newHints[cardId];
          }
        }
        setScore(newCorrect.size * config.settings.pointsPerCorrect);
      } else {
        playTone("drop");
      }

      setAnswers(newAnswers);
      setCorrectCards(newCorrect);
      setWrongRows(newWrong);
      setShownHints(newHints);
      setSlotInId(cardId);
      setTimeout(() => setSlotInId(null), 300);
    },
    [
      answers,
      correctCards,
      wrongRows,
      shownHints,
      isSubmitted,
      shuffledCards,
      feedbackMode,
      allowReuse,
      streak,
      showLockedToastFn,
      showStreakPopup,
      config.settings.pointsPerCorrect,
    ],
  );

  const clearDrop = useCallback(
    (cardId: number) => {
      if (isSubmitted) {
        showLockedToastFn();
        return;
      }
      if (!answers[cardId]) return;

      const newAnswers = { ...answers };
      delete newAnswers[cardId];
      const newCorrect = new Set(correctCards);
      newCorrect.delete(cardId);
      const newHints = { ...shownHints };
      delete newHints[cardId];

      setAnswers(newAnswers);
      setCorrectCards(newCorrect);
      setShownHints(newHints);
      if (feedbackMode === "immediate") {
        setScore(newCorrect.size * config.settings.pointsPerCorrect);
      }
      playTone("drop");
    },
    [answers, correctCards, shownHints, isSubmitted, feedbackMode, showLockedToastFn, config.settings.pointsPerCorrect],
  );

  const handleSubmit = useCallback(() => {
               const newCorrect = new Set<number>();
        const newHints: Record<number, { text: string; cls: string }> = {};
        const newWrong = new Set<number>();

        shuffledCards.forEach((card) => {
          const userAnswer = answers[card.id];
          if (userAnswer === card.answer) {
            newCorrect.add(card.id);
            if (card.feedback) {
              newHints[card.id] = { text: "✓ " + card.feedback, cls: "hint correct" };
            }
          } else {
            newWrong.add(card.id);
            newHints[card.id] = { text: "💡 " + (card.hint || "Incorrect"), cls: "hint wrong" };
          }
        });

        const newScore = newCorrect.size * config.settings.pointsPerCorrect;
        setlearnerActivityrec((prev: any) =>
          updateDragForNowBlockcategory(
            prev,
            {
              blockId: data.blockId,
              attempt: attempt,
              type:"category",
              round: currentRound + 1,
              score:newScore,
              answer: shuffledCards.map((card) => ({
                cardId: card.id,
                selectedOption: answers[card.id] ?? null,
                correctOption: card.answer,
                isCorrect:
                  answers[card.id] === card.answer
              })),
              correctCount: newCorrect.size,
            },
            deviceInfo
          )
        );
    if (feedbackMode === "delayed") {
      if (!isSubmitted) {
        // Validate all answers
        if (timerRef.current) clearInterval(timerRef.current);

        setCorrectCards(newCorrect);
        setShownHints(newHints);
        setWrongRows(newWrong);
        setScore(newScore);
        setIsSubmitted(true);
        playTone(newCorrect.size === cards.length ? "fanfare" : newCorrect.size > 0 ? "correct" : "wrong");
      } else {
        // Second click = completion
        finishGame(correctCards.size);
        handleContinue();
      }
    } else {
      // Immediate mode
      if (timerRef.current) clearInterval(timerRef.current);
      finishGame(correctCards.size);
      handleContinue(); // ✅ CALL HERE
    }
  }, [feedbackMode, isSubmitted, answers, shuffledCards, correctCards, cards.length, config.settings.pointsPerCorrect]);

  const finishGame = useCallback(
    (numCorrect: number) => {
      const finalScore = numCorrect * config.settings.pointsPerCorrect;
      if (originalScoreRef.current === null) {
        originalScoreRef.current = finalScore;
        highestScoreRef.current = finalScore;
      } else if (finalScore > highestScoreRef.current) {
        highestScoreRef.current = finalScore;
      }
      setScore(finalScore);
      setGameComplete(true);

      const scoreData = {
        type: "SMART_GOALS_LAB_COMPLETE",
        originalScore: originalScoreRef.current,
        finalScore: highestScoreRef.current,
        replayCount: replayCountRef.current,
      };
      window.postMessage(scoreData, "*");
      if (window.parent !== window) window.parent.postMessage(scoreData, "*");
    },
    [config.settings.pointsPerCorrect],
  );

  const handleTimeupDismiss = useCallback(() => {
    setShowTimeup(false);
    handleSubmit();

  }, [handleSubmit]);

  const handleReplay = useCallback(() => {
    replayCountRef.current++;
     const newAttempts = attempt + 1;
    setAttempt(newAttempts);
    playTone("drop");
    setShuffledCards(shuffleArray(cards));
    setAnswers({});
    setCorrectCards(new Set());
    setStreak(0);
    setIsSubmitted(false);
    setGameComplete(false);
    setScore(0);
    setWrongRows(new Set());
    setShownHints({});
    setTimeLeft(config.settings.timePerRound);
  }, [cards, config.settings.timePerRound]);

  const handleCardClick = useCallback(
    (e: React.MouseEvent) => {
      if (isSubmitted && feedbackMode === "delayed") {
        const t = e.target as HTMLElement;
        if (
          t.closest(".submit-btn") ||
          t.closest(".completion-overlay") ||
          t.closest(".timeup-overlay") ||
          t.closest(".replay-btn")
        )
          return;
        showLockedToastFn();
      }
    },
    [isSubmitted, feedbackMode, showLockedToastFn],
  );

  const usedElements = !allowReuse ? new Set(Object.values(answers)) : new Set<string>();
  const completionMsg = getCongratulatoryMessage(correctCards.size, cards.length);

  return (
    <GameContainer>
      {gameComplete && <ConfettiCanvas />}
      <div className="w-full h-full" data-aos="slide-up" data-aos-delay="200" data-aos-once="true">
      <div className={`card  ${gameComplete ? "complete" : ""}`} ref={cardRef} onClick={handleCardClick}>
        {/* Streak popup */}
        {streakPopup && <div className={`streak-popup ${streakPopup.cls}`}>{streakPopup.text}</div>}

        {/* Time's up overlay */}
        {showTimeup && (
          <div className="timeup-overlay show">
            <div className="timeup-dialog">
              {/* <div className="timeup-head">
                <strong>Time's up!</strong>
              </div> */}

              {/* <div
  className="timeup-head"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  <strong>Time's up!</strong>
</div> */}

{/* <div
  className="timeup-head"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "20px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  <strong>Time's up!</strong>
</div> */}

<div className="timeup-head">
  <strong
    style={{
      fontSize: "20px",
      lineHeight: "1.5",
    }}
  >
    Time's up!
  </strong>
</div>





              {/* <p className="timeup-text">You ran out of time to make a choice.</p> */}
              {/* <p
  className="timeup-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You ran out of time to make a choice.
</p> */}

<p
  className="timeup-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You ran out of time to make a choice.
</p>
              <div className="timeup-actions">
                {/* <button className="ghost" onClick={handleTimeupDismiss}>
                  Got it
                </button> */}

                <button
  className="ghost"
onClick={handleTimeupDismiss}
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "15px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button>
              </div>
            </div>
          </div>
        )}

        {/* Locked toast */}
        <div className={`locked-toast ${lockedToast ? "show" : ""}`}>
          🔒 Choices are locked! Please click on the <b>Next</b> button to proceed.
        </div>

        {/* Completion overlay */}
        {gameComplete && (
          <CompletionScreen
            averageScore={averageScore}
            currentGameScore={currentGameScore}
            score={score}
            bestScore={bestScore}
            maxPoints={maxPoints}
            message={completionMsg}
            allowReplay={config.settings.allowReplay}
            onReplay={handleReplay}
             onComplete={() => onCompleted?.()}
          />
        )}

        {/* Topbar */}
        {!gameComplete && (
          <div className="topbar">
            <div className="title">
              {/* <h1  className="font-bold">{config.title}</h1> */}
              {/* <h1
  className="font-bold"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "18px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1> */}

<h1
  className="font-bold"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "20px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "18px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1>
              {/* <p>{config.subtitle}</p> */}
              {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.subtitle}
</p> */}


<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "20px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "18px",

    lineHeight: "1.5",
    margin: 0,

    // 👇 same wrap behavior for all zoom levels
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  }}
>
  {config.subtitle}
</p>
            </div>
            {/* <div className="badge" style={{ display: "flex", alignItems: "center", gap: "14px" }}> */}
            {/* <div
  className="badge"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "14px",
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<div
  className="badge"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "14px",
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
              {config.settings.timerEnabled && (
                <div className={`timer-ring ${timerState}`}>
                  <svg viewBox="0 0 40 40">
                    <circle className="timer-bg" cx="20" cy="20" r="18" />
                    <circle
                      className="timer-progress"
                      cx="20"
                      cy="20"
                      r="18"
                      strokeDasharray={circumference}
                      strokeDashoffset={timerOffset}
                      style={{
                        stroke:
                          timerState === "danger"
                            ? "var(--bad)"
                            : timerState === "warning"
                              ? "var(--gold)"
                              : "var(--cyan)",
                        transition: "stroke-dashoffset 1s linear, stroke 0.3s ease",
                      }}
                    />
                  </svg>
                  <div className="timer-text">{timeLeft}</div>
                </div>
              )}
              {/* <span className="pts">
                <b>{currentPoints}</b>
                <span style={{ opacity: 0.55 }}>/</span>
                <span>{maxPoints}</span>
                <span style={{ opacity: 0.6 }}>pts</span>
              </span>
              <span style={{ opacity: 0.25 }}>|</span>
              <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span className="dot"></span>
                <span>
                  {answeredCount}/{cards.length} tagged
                </span>
              </span>
              {streak >= 2 && (
                <span className="streak-badge">🔥 <span>{streak}</span></span>
              )} */}

              {/* <span
  className="pts"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<span
  className="pts"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  <b>{currentPoints}</b>
  <span style={{ opacity: 0.55 }}>/</span>
  <span>{maxPoints}</span>
  <span style={{ opacity: 0.6 }}>pts</span>
</span>

{/* <span
  style={{
    opacity: 0.25,
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
  }}
>
  |
</span> */}

<span
  style={{
    opacity: 0.25,
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
  }}
>
  |
</span>

{/* <span
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
  }}
> */}

<span
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
  }}
>
  <span className="dot"></span>

  {/* <span
    style={{
      fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    }}
  > */}

  <span
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
  }}
>
    {answeredCount}/{cards.length} tagged
  </span>
</span>

{streak >= 2 && (
  // <span
  //   className="streak-badge"
  //   style={{
  //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
  //     lineHeight: "1.5",
  //   }}
  // >

  <span
  className="streak-badge"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
  }}
>
    🔥 <span>{streak}</span>
  </span>
)}
            </div>
          </div>
        )}

        {/* Content */}
        {!gameComplete && (
          <div className="content">
            <div className="elements-container">
              <div className="elements-row">
                  {config.elements.map((el: any, index: number) => (
                    <div key={el} data-aos="zoom-in-right" data-aos-delay={600 + index * 100}>
                  <div
                   
                    className={`smart-chip ${draggingChip === el ? "dragging" : ""}`}
                    // style={!allowReuse && usedElements.has(el) ? { display: "none" } : undefined}
  //                     style={{
  //   ...(!allowReuse && usedElements.has(el) ? { display: "none" } : {undefined}),
  //   fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
  //   lineHeight: "1.5",
  //   margin: 0,
  // }}

  style={{
  ...(!allowReuse && usedElements.has(el) ? { display: "none" } : {}),
  fontSize:
    window.devicePixelRatio <= 1
      ? "18px"
      : window.devicePixelRatio <= 1.5
      ? "15px"
      : "16px",
  lineHeight: "1.5",
  margin: 0,
}}
                    draggable={!isSubmitted}
                    onDragStart={(e) => {
                      if (isSubmitted) {
                        e.preventDefault();
                        showLockedToastFn();
                        return;
                      }
                      setDraggingChip(el);
                      e.dataTransfer.setData("text/plain", el);
                      e.dataTransfer.effectAllowed = "copy";
                      playTone("drop");
                    }}
                    onDragEnd={() => setDraggingChip(null)}
                  >
                    {el}
                      </div>
                  </div>
                ))}
                {/* {config.elements.map((el: any) =>
  el.categories.map((cat: string) => (
    <div
      key={cat}
      className={`smart-chip ${draggingChip === cat ? "dragging" : ""}`}
      style={!allowReuse && usedElements.has(cat) ? { display: "none" } : undefined}
      draggable={!isSubmitted}
      onDragStart={(e) => {
        if (isSubmitted) {
          e.preventDefault();
          showLockedToastFn();
          return;
        }

        setDraggingChip(cat);
        e.dataTransfer.setData("text/plain", cat);
        e.dataTransfer.effectAllowed = "copy";
        playTone("drop");
      }}
      onDragEnd={() => setDraggingChip(null)}
    >
      {cat}
    </div>
  ))
)} */}

                {answeredCount === cards.length && (
                  <button className="submit-btn show" onClick={handleSubmit}>
                    {isSubmitted ? "Next" : "Submit"}
                  </button>
                )}
              </div>
            </div>
            <div className="chat" ref={chatRef}>
              <div className="goals-list">
                {shuffledCards.map((card) => {
                  const ans = answers[card.id];
                  const isCorrect = correctCards.has(card.id);
                  const isWrong = wrongRows.has(card.id);
                  const hintInfo = shownHints[card.id];
                  return (
                    <div className="goal-wrapper" key={card.id}>
                      <div
                        className={`goal-row ${isCorrect ? "correct" : ""} ${isWrong ? "wrong" : ""} ${dragOverId === card.id ? "drag-over" : ""}`}
                        onDragOver={(e) => {
                          e.preventDefault();
                          e.dataTransfer.dropEffect = "copy";
                          setDragOverId(card.id);
                        }}
                        onDragLeave={(e) => {
                          if (!(e.currentTarget as HTMLElement).contains(e.relatedTarget as Node)) setDragOverId(null);
                        }}
                        onDrop={(e) => {
                          e.preventDefault();
                          setDragOverId(null);
                          const el = e.dataTransfer.getData("text/plain");
                          if (el) handleDrop(card.id, el);
                        }}
                      >
                        {/* <div className="goal-text">{card.goal}</div> */}

                        {/* <div
  className="goal-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
  }}
> */}

<div
  className="goal-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
  }}
>
  {card.goal}
</div>
                        <div
                          className={`drop-zone ${ans ? "filled" : ""} ${slotInId === card.id ? "slot-in" : ""} ${dragOverId === card.id && !ans ? "drag-over" : ""}`}
  //                           style={{
  //   fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
  //   lineHeight: "1.5",
  // }}

  style={{
  fontSize:
    window.devicePixelRatio <= 1
      ? "18px"
      : window.devicePixelRatio <= 1.5
      ? "15px"
      : "16px",
  lineHeight: "1.5",
}}
                          onClick={() => clearDrop(card.id)}
                          draggable={!!ans && !isSubmitted}
                          onDragStart={(e) => {
                            if (isSubmitted) {
                              e.preventDefault();
                              showLockedToastFn();
                              return;
                            }
                            if (ans) {
                              setDraggingChip(ans);
                              e.dataTransfer.setData("text/plain", ans);
                              e.dataTransfer.effectAllowed = "copy";
                              playTone("drop");
                            }
                          }}
                          onDragEnd={() => setDraggingChip(null)}
                        >
                          {ans || "Drop here"}
                        </div>
                        {isCorrect && <div className="correct-indicator">✓</div>}
                      </div>
                      {hintInfo && <div className={hintInfo.cls}>{hintInfo.text}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
            {showScroll && <div className="scroll-indicator show"></div>}
          </div>
        )}
      </div>
      </div>
      <div className="particle-container" ref={particleRef}></div>
    </GameContainer>
  );
};

/* ═══════════════════════════════════════════════
   RANKING GAME
   ═══════════════════════════════════════════════ */
interface RankItem {
  id: number;
  text: string;
  correctRank: any | null;
  hint: string;
  feedback: string;
}

const RankingGame: React.FC<GameProps> = ({ averageScore,config, onComplete, bestScore,currentGameScore,  onCompleted,isTimerPaused,data }) => {
  const items: RankItem[] = config.rounds.map((r:any, i:any) => ({
    id: parseInt(r.id) || i + 1,
    text: r.text,
    correctRank: r.correctRank ?? null,
    hint: r.why || "",
    feedback: r.feedback || "",
  }));

  const validRankCount = items.filter(item => item.correctRank !== "").length;

  const maxPoints = validRankCount * config.settings.pointsPerCorrect;
 const [attempt, setAttempt] = useState(1);
  const {setlearnerActivityrec,deviceInfo} = useContext(ScoreContext);
  const correctrankbadge = items.filter(item => item.correctRank !== "");
  // const correctPicksCount = items.filter((i) => i.correctRank != null).length;
  const correctPicksCount = items.filter((i) => i.correctRank !== "").length;
  const [currentOrder, setCurrentOrder] = useState(() => shuffleArray(items));
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [submitted, setSubmitted] = useState(false);
  const [showingFeedback, setShowingFeedback] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(config.settings.timePerRound);
  const [showTimeup, setShowTimeup] = useState(false);
  const [lockedToast, setLockedToast] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const [feedbackResults, setFeedbackResults] = useState<Record<number, string>>({});
  const [feedbackBadges, setFeedbackBadges] = useState<Record<number, string>>({});
  const [shownHints, setShownHints] = useState<Record<number, { text: string; color: string }>>({});
  const [showFeedback, setShowFeedback] = useState(false);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [showWipe, setShowWipe] = useState(false)
  const [currentRound, setCurrentRound] = useState(0);
  const cardRef = useRef<HTMLDivElement>(null);
  const particleRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const lockedToastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const replayCountRef = useRef(0);
  const originalScoreRef = useRef<number | null>(null);
  const highestScoreRef = useRef(0);
  const lastCorrectCountRef = useRef(0);
  const statementCardRef = useRef<HTMLDivElement>(null);

  const circumference = 2 * Math.PI * 18;
  const timerOffset = circumference * (1 - timeLeft / config.settings.timePerRound);
  const timerState = timeLeft <= 5 ? "danger" : timeLeft <= 10 ? "warning" : "";
  const currentPoints = Number(score);
  // Timer
  useEffect(() => {
    if (!config.settings.timerEnabled || gameComplete || submitted ) return;
    // setTimeLeft(config.settings.timePerRound);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev:any) => {
        if (prev <= 1) {
          if (timerRef.current) clearInterval(timerRef.current);
          setShowTimeup(true);
          playTone("wrong");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [gameComplete, submitted]);
  useEffect(() => {
  if (gameComplete) {
    onComplete(currentPoints, maxPoints);
  }
}, [gameComplete]);
  const handleContinue = () => {
    playTone("tap");
    setShowFeedback(false);
    if (currentRound >= config.rounds.length - 1) {
      setGameComplete(true);
      const earned = currentPoints;
      const max = maxPoints;

      // onComplete(earned, max); // ✅ Send score up
    } else {
      setShowWipe(true);
      playTone("whoosh");
      setTimeout(() => {
        // Reset statement card before advancing round
        const el = statementCardRef.current;
        if (el) {
          el.classList.remove("swipe-left", "swipe-right", "enter-from-left", "enter-from-right");
          el.style.cssText = "";
        }
        setCurrentRound((prev) => prev + 1);
        setLockedToast(false);
        setShowFeedback(false);
        // setAnswers(null);
        setAnswers({}); 
        setShowWipe(false);
      }, 500);
    }
  };
  // Particle trail
  useEffect(() => {
    const handler = (e: DragEvent) => {
      if (draggedIndex !== null && particleRef.current) {
        const p = document.createElement("div");
        p.className = "particle";
        p.style.left = e.clientX + "px";
        p.style.top = e.clientY + "px";
        const colors = ["rgba(54,231,255,.6)", "rgba(180,107,255,.6)"];
        p.style.background = colors[Math.floor(Math.random() * colors.length)];
        p.style.boxShadow = "0 0 6px " + p.style.background;
        particleRef.current.appendChild(p);
        setTimeout(() => p.remove(), 600);
      }
    };
    document.addEventListener("dragover", handler);
    return () => document.removeEventListener("dragover", handler);
  }, [draggedIndex]);

  const showLockedToastFn = useCallback(() => {
    setLockedToast(true);
    if (lockedToastTimer.current) clearTimeout(lockedToastTimer.current);
    lockedToastTimer.current = setTimeout(() => setLockedToast(false), 3000);
  }, []);

  const toggleSelection = useCallback(
    (itemId: number) => {
      if (submitted) {
        showLockedToastFn();
        return;
      }
      setSelectedItems((prev) => {
        const idx = prev.indexOf(itemId);
        if (idx !== -1) {
          const next = [...prev];
          next.splice(idx, 1);
          return next;
        }
        if (prev.length >= validRankCount) return prev;
        playTone("select");
        return [...prev, itemId];
      });
    },
    [submitted, validRankCount, showLockedToastFn],
  );

  const getCongratulatoryMessage = useCallback(
    (numCorrect: number, total: number) => {
      const percent = Math.round((numCorrect / total) * 100);
      const sorted = [...config.settings.congratulatoryMessages]
        .filter((m) => m.message?.trim())
        .sort((a, b) => b.minPercent - a.minPercent);
      for (const msg of sorted) {
        if (percent >= msg.minPercent && percent <= msg.maxPercent) return msg.message;
      }
      if (sorted.length > 0) {
        for (const msg of sorted) {
          if (percent <= msg.maxPercent) return msg.message;
        }
      }
      return "";
    },
    [config.settings.congratulatoryMessages],
  );

  const handleSubmit = useCallback(() => {

    if (showingFeedback) {
      // Go to completion
      const finalScore = lastCorrectCountRef.current * config.settings.pointsPerCorrect;
      if (originalScoreRef.current === null) {
        originalScoreRef.current = finalScore;
        highestScoreRef.current = finalScore;
      } else if (finalScore > highestScoreRef.current) {
        highestScoreRef.current = finalScore;
      }
        setlearnerActivityrec((prev: any) =>
        updateDragForNowBlock(
          prev,
          {
            blockId: data.blockId,
            attempt: attempt,
            type:"ranking",
            finalscoreearned: finalScore
          },
          deviceInfo
        )
      );
      setScore(finalScore);
      setGameComplete(true);
      handleContinue();
      const scoreData = {
        type: "RANKING_GAME_COMPLETE",
        originalScore: originalScoreRef.current,
        finalScore: highestScoreRef.current,
        replayCount: replayCountRef.current,
      };
      window.postMessage(scoreData, "*");
      if (window.parent !== window) window.parent.postMessage(scoreData, "*");
      return;
    }

    if (submitted) return;
    setSubmitted(true);
    setShowingFeedback(true);
    if (timerRef.current) clearInterval(timerRef.current);

    const correctPicks = items
      .filter((i) => i.correctRank !== "")
      .sort((a, b) => Number(a.correctRank) - Number(b.correctRank))
      .map((i) => i.id);

    let correctCount = 0;
    const results: Record<number, string> = {};
    const badges: Record<number, string> = {};
    const hints: Record<number, { text: string; color: string }> = {};

    currentOrder.forEach((item) => {
      const isSelected = selectedItems.includes(item.id);
      const isCorrectPick = item.correctRank != null;
       const isnotCorrectrank = String(item.correctRank) === "";
      const playerPos = selectedItems.indexOf(item.id);
      const correctPos = correctPicks.indexOf(item.id);

      if (!isSelected) return;

      if (isnotCorrectrank) {
        results[item.id] = "wrong";
        badges[item.id] = "Wrong choice";

      }
       else if (isCorrectPick) {
        if (playerPos === correctPos) {
          correctCount++;
          results[item.id] = "correct";
          badges[item.id] = "Correct Choice";

          if (item.feedback?.trim()) {
            hints[item.id] = { text: "✓ " + item.feedback, color: "var(--good)" };
          } else if (item.hint?.trim()) {
            hints[item.id] = { text: "✓ Correct!", color: "var(--good)" };
          }

          return;
        }

        results[item.id] = "wrong";
        badges[item.id] = "Wrong order";

      } else {
        results[item.id] = "wrong";
        badges[item.id] = "Wrong choice";
      }

      // ✅ Common hint handler
      if (item.hint?.trim()) {
        hints[item.id] = { text: "💡 " + item.hint, color: "var(--gold)" };
      }
    });

    lastCorrectCountRef.current = correctCount;
    const newScore = correctCount * config.settings.pointsPerCorrect;
     setlearnerActivityrec((prev: any) =>
      updateDragForNowBlock(
        prev,
        {
          blockId: data.blockId,
          attempt: attempt,
          type:"ranking",
          round: currentRound + 1,
          score: newScore,
          selectedItems: [...selectedItems],
          submittedOrder: currentOrder.map((item) => ({
            id: item.id,
            title: item,
            correctRank: item.correctRank,
            playerRank: selectedItems.indexOf(item.id) + 1,
            isSelected: selectedItems.includes(item.id)
          })),
          correctCount,
          totalCorrect: correctPicksCount
        },
        deviceInfo
      )
    );
    setScore(newScore);
    setFeedbackResults(results);
    setFeedbackBadges(badges);
    setShownHints(hints);
    handleContinue(); // ✅ CALL HERE
    playTone(correctCount === correctPicksCount ? "fanfare" : correctCount > 0 ? "correct" : "wrong");

  }, [
    showingFeedback,
    submitted,
    selectedItems,
    currentOrder,
    items,
    correctPicksCount,
    config.settings.pointsPerCorrect,
  ]);

  const handleReset = useCallback(() => {
    playTone("drop");
    setScore(0);
    setSelectedItems([]);
    setSubmitted(false);
    setShowingFeedback(false);
    setFeedbackResults({});
    setFeedbackBadges({});
    setShownHints({});
    setCurrentOrder(shuffleArray(items));
    // if (config.settings.timerEnabled) setTimeLeft(config.settings.timePerRound);
  }, [items, config.settings.timerEnabled, config.settings.timePerRound]);

  const handleReplay = useCallback(() => {
     const newAttempts = attempt + 1;
    setAttempt(newAttempts);
    replayCountRef.current++;
    playTone("drop");
    setGameComplete(false);
     setTimeLeft(config.settings.timePerRound);
    handleReset();
  }, [handleReset]);

  const handleTimeupDismiss = useCallback(() => {
    setShowTimeup(false);
    setSubmitted(true);
    setShowingFeedback(true);
    lastCorrectCountRef.current = 0;
    // Go to completion with 0
    const finalScore = 0;
    if (originalScoreRef.current === null) {
      originalScoreRef.current = finalScore;
      highestScoreRef.current = finalScore;
    }
    setScore(finalScore);
    setGameComplete(true);
    const scoreData = {
      type: "RANKING_GAME_COMPLETE",
      originalScore: originalScoreRef.current!,
      finalScore: highestScoreRef.current,
      replayCount: replayCountRef.current,
    };
    window.postMessage(scoreData, "*");
    if (window.parent !== window) window.parent.postMessage(scoreData, "*");
  }, []);

  const handleCardClick = useCallback(
    (e: React.MouseEvent) => {
      if (submitted) {
        const t = e.target as HTMLElement;
        if (
          t.closest(".submit-btn") ||
          t.closest(".completion-overlay") ||
          t.closest(".timeup-overlay") ||
          t.closest(".replay-btn") ||
          t.closest(".reset-btn")
        )
          return;
        showLockedToastFn();
      }
    },
    [submitted, showLockedToastFn],
  );

  const completionMsg = getCongratulatoryMessage(lastCorrectCountRef.current, correctPicksCount);


  const correctSelectedCount = currentOrder.filter(
    item =>
      selectedItems.includes(item.id) 
    // &&
    //   item.correctRank !== ""
  ).length;

  const correctCount = currentOrder.filter(
    item =>item.correctRank !== ""
  ).length;
  return (
    <GameContainer>
      {gameComplete && <ConfettiCanvas />}
      <div className="w-full h-full" data-aos="slide-down" data-aos-delay="200" data-aos-once="true">
      <div className={`card ${gameComplete ? "complete" : ""}`} ref={cardRef} onClick={handleCardClick}>
        {/* Time's up */}
        {showTimeup && (
          <div className="timeup-overlay show">
            <div className="timeup-dialog">
              {/* <div className="timeup-head">
                <strong>Time's up!</strong>
              </div> */}
              {/* <div
  className="timeup-head"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}
<div className="timeup-head">
  <strong
    style={{
      fontSize: "20px",
      lineHeight: "1.5",
    }}
  >
    Time's up!
  </strong>
</div>
              {/* <p className="timeup-text">You ran out of time to make a choice.</p> */}
              {/* <p
  className="timeup-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<p
  className="timeup-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You ran out of time to make a choice.
</p>
              <div className="timeup-actions">
                {/* <button className="ghost" onClick={handleTimeupDismiss}>
                  Got it
                </button> */}

                {/* <button
  className="ghost"
  onClick={handleTimeupDismiss}
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button> */}

<button
  className="ghost"
  onClick={handleTimeupDismiss}
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button>
              </div>
            </div>
          </div>
        )}

        {/* Locked toast */}
        <div className={`locked-toast ${lockedToast ? "show" : ""}`}>
          🔒 Choices are locked! Please click on the <b>Next</b> button to proceed.
        </div>

        {/* Completion */}
        {gameComplete && (
          <CompletionScreen
            averageScore={averageScore}
            score={score}
            currentGameScore={currentGameScore}
            maxPoints={maxPoints}
            message={completionMsg}
            allowReplay={config.settings.allowReplay}
            onReplay={handleReplay}
            bestScore={bestScore}
             onComplete={() => onCompleted?.()}
          />
        )}

        {/* Topbar */}
        {!gameComplete && (
          <div className="topbar">
            <div className="title">
              <h1 className="font-bold">{config.title}</h1>
              {/* <p>{config.subtitle}</p> */}
              {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
    margin: 0,
     whiteSpace: "normal",
  overflowWrap: "break-word"
  }}
>
  {config.subtitle}
</p> */}

<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  }}
>
  {config.subtitle}
</p>
            </div>
            <div className="badge" style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              {config.settings.timerEnabled && (
                <div className={`timer-ring ${timerState}`}>
                  <svg viewBox="0 0 40 40">
                    <circle className="timer-bg" cx="20" cy="20" r="18" />
                    <circle
                      className="timer-progress"
                      cx="20"
                      cy="20"
                      r="18"
                      strokeDasharray={circumference}
                      strokeDashoffset={timerOffset}
                      style={{
                        stroke:
                          timerState === "danger"
                            ? "var(--bad)"
                            : timerState === "warning"
                              ? "var(--gold)"
                              : "var(--cyan)",
                        transition: "stroke-dashoffset 1s linear, stroke 0.3s ease",
                      }}
                    />
                  </svg>
                  <div className="timer-text">{timeLeft}</div>
                </div>
              )}
              <span className="pts">
                <b>{currentPoints}</b>
                <span style={{ opacity: 0.55 }}>/</span>
                <span>{maxPoints}</span>
                <span style={{ opacity: 0.6 }}>pts</span>
              </span>
              <span style={{ opacity: 0.25 }}>|</span>
              <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span className="dot"></span>
                <span>
                  {/* {selectedItems.length}/{correctPicksCount} selected */}
                  {correctSelectedCount}/{correctCount} selected
                </span>
              </span>
            </div>
          </div>
        )}

        {/* Content */}
        {!gameComplete && (
          <>
            <div className="content">
              <div className="ranking-list">
                {currentOrder.map((item, index) => {
                  const selIdx = selectedItems.indexOf(item.id);
                  const isSelected = selIdx !== -1;
                  const result = feedbackResults[item.id];
                  const badge = feedbackBadges[item.id];
                  const hintInfo = shownHints[item.id];

                  return (
                    <div className="item-wrapper" key={item.id}>
                      <div
                        className={`ranking-item ${isSelected ? "selected" : ""} ${result || ""} ${draggedIndex === index ? "dragging" : ""} ${dragOverIndex === index ? "drag-over" : ""}`}
                        draggable={!submitted}
                        onDragStart={(e) => {
                          if (submitted) {
                            e.preventDefault();
                            showLockedToastFn();
                            return;
                          }
                          setDraggedIndex(index);
                          e.dataTransfer.effectAllowed = "move";
                          e.dataTransfer.setData("text/plain", index.toString());
                          playTone("drop");
                        }}
                        onDragEnd={() => {
                          setDraggedIndex(null);
                          setDragOverIndex(null);
                        }}
                        onDragOver={(e) => {
                          e.preventDefault();
                          if (!submitted) setDragOverIndex(index);
                        }}
                        onDragLeave={() => setDragOverIndex(null)}
                        onDrop={(e) => {
                          e.preventDefault();
                          if (submitted) return;
                          setDragOverIndex(null);
                          const fromIdx = draggedIndex;
                          if (fromIdx === null || fromIdx === index) return;
                          const newOrder = [...currentOrder];
                          // const [moved] = newOrder.splice(fromIdx, 1);
                          // newOrder.splice(index, 0, moved);
                          const [moved] = newOrder.splice(fromIdx, 1);
const toIdx = fromIdx < index ? index - 1 : index;
newOrder.splice(toIdx, 0, moved);
                          // Update selected order
                          const newSelected = newOrder.filter((i) => selectedItems.includes(i.id)).map((i) => i.id);
                          setCurrentOrder(newOrder);
                          setSelectedItems(newSelected);
                        }}
                        onClick={(e) => {
                          if ((e.target as HTMLElement).closest(".drag-handle")) return;
                          toggleSelection(item.id);
                        }}
                      >
                        <div className="drag-handle">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div
                          className="select-indicator"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(item.id);
                          }}
                        ></div>
                        {/* <div className="item-text">{item.text}</div> */}
                        {/* <div
  className="item-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "inherit",
    lineHeight: "1.5",
  }}
> */}

<div
  className="item-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
  }}
>
  {item.text}
</div>
                        {isSelected && (
                          <div className="rank-badge" style={{ display: "flex" }}>
                            #{selIdx + 1}
                          </div>
                        )}
                        {badge && (
                          <div className="feedback-badge-container">
                            <span
                                className={`feedback-badge ${badge === "Wrong choice" ? "wrong-choice" : badge === "Correct Choice" ? "Correct-Choice" : "wrong-order"}`}
                            >
                              {badge}
                            </span>
                          </div>
                        )}
                        {result && (
                          <div
                            className={`result-indicator`}
                            style={{
                              display: "flex",
                              background: result === "correct" ? "var(--good)" : "var(--bad)",
                              color: result === "correct" ? "#000" : "#fff",
                            }}
                          >
                            {result === "correct" ? "✓" : "✗"}
                          </div>
                        )}
                      </div>
                      {hintInfo && (
                        <div className="hint-text show" style={{ color: hintInfo.color }}>
                          {hintInfo.text}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="footer">
              <span className="footer-hint">Tap to pick 1 → 2 → 3 in order. Drag to change order.</span>
              {!submitted && (
                <button className="reset-btn" onClick={handleReset}>
                  Reset
                </button>
              )}
              <button className="submit-btn" onClick={handleSubmit}>
                {showingFeedback ? "Next" : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
      </div>
      <div className="particle-container" ref={particleRef}></div>
    </GameContainer>
  );
};

/* ═══════════════════════════════════════════════
   COMPLETION SCREEN
   ═══════════════════════════════════════════════ */
interface CompletionProps {
  averageScore: number;
  score: number;
  maxPoints: number;
  currentGameScore:any;
  message: string;
  allowReplay: boolean;
  onReplay: () => void;
  bestScore:any;
   onComplete: () => void;
}

const CompletionScreen: React.FC<CompletionProps> = ({averageScore, score,currentGameScore, maxPoints, message, allowReplay, onReplay,bestScore,onComplete }) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    playTone("fanfare");
    setTimeout(() => playTone("complete"), 600);
onComplete();
    const check = () => {
      const el = overlayRef.current;
      if (!el) return;
      const content = el.querySelector(".completion-content") as HTMLElement;
      if (!content) return;
      const needsScroll = content.getBoundingClientRect().height > el.clientHeight - 4;
      el.style.overflowY = needsScroll ? "auto" : "hidden";
      el.style.overflowX = "hidden";
    };
    requestAnimationFrame(check);
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <div className="completion-overlay show" ref={overlayRef}>
      <div className="completion-content">
        <div className="completion-emoji">🎉</div>
        <h2 className="completion-title">Congratulations!</h2>
        {/* <p className="completion-subtitle">You completed the mini-game.</p> */}
        {/* <p
  className="completion-subtitle"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<p
  className="completion-subtitle"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You completed the mini-game.
</p>
        <div className="completion-score">
          {score}/{maxPoints} pts
          {/* {currentGameScore}/{maxPoints} pts */}
          {/* {bestScore}/{maxPoints} pts */}
        </div>
        {/* {message && <p className="completion-message">{message}</p>} */}
  {message && (
  // <p
  //   className="completion-message"
  //   style={{
  //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
  //     lineHeight: "1.5",
  //     margin: 0,
  //     whiteSpace: "nowrap",
  //   }}
  // >
  //   {message}
  // </p>

//   <p
//   className="completion-message"
//   style={{
//     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
//     lineHeight: "1.5",
//     margin: 0,
//     whiteSpace: "nowrap",
//     width: "100%",
//     display: "flex",
//     justifyContent: "center",
//   }}
// >

<p
  className="completion-message"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
    whiteSpace: "nowrap",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  }}
>
  {message}
</p>
)}
        {allowReplay && (
          <button className="replay-btn" onClick={onReplay}>
            🔄 Replay Mini-Game
          </button>
        )}
        {/* <p className="next-instruction">
          Or click on the <b>Next</b> button at the right to proceed to the next interaction.
        </p> */}

        {/* <p
  className="next-instruction"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
    lineHeight: "2.5",
    margin: 0,
  }}
> */}

<p
  className="next-instruction"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "2.5",
    margin: 0,
  }}
>
  Or click on the <b>Next</b> button at the right to proceed to the next interaction.
</p>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════
   CONFETTI CANVAS
   ═══════════════════════════════════════════════ */
const ConfettiCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles: any[] = [];
    const colors = ["rgba(54,231,255,0.9)", "rgba(180,107,255,0.9)", "rgba(255,255,255,0.8)", "rgba(100,255,218,0.9)"];
    const cx = canvas.width / 2,
      cy = canvas.height / 2;

    for (let i = 0; i < 120; i++) {
      const angle = (Math.PI * 2 * i) / 120 + Math.random() * 0.5;
      const speed = Math.random() * 8 + 4;
      particles.push({
        x: cx,
        y: cy,
        size: Math.random() * 6 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        speedX: Math.cos(angle) * speed,
        speedY: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 15 - 7.5,
        alpha: 1,
        decay: Math.random() * 0.015 + 0.008,
        type: Math.random() > 0.5 ? "hex" : "diamond",
      });
    }

    const drawShape = (x: number, y: number, size: number, rot: number, sides: number) => {
      ctx.beginPath();
      for (let i = 0; i < sides; i++) {
        const a = ((Math.PI * 2) / sides) * i + rot;
        const px = x + size * Math.cos(a),
          py = y + size * Math.sin(a);
        i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += 0.15;
        p.speedX *= 0.99;
        p.rotation += p.rotationSpeed;
        p.alpha -= p.decay;
        if (p.alpha > 0) {
          ctx.save();
          ctx.globalAlpha = p.alpha;
          ctx.fillStyle = p.color;
          ctx.shadowBlur = 12;
          ctx.shadowColor = p.color;
          drawShape(p.x, p.y, p.size, (p.rotation * Math.PI) / 180, p.type === "hex" ? 6 : 4);
          ctx.fill();
          ctx.restore();
        }
      });
      if (particles.some((p) => p.alpha > 0)) requestAnimationFrame(animate);
    };
    animate();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 9999 }}
    />
  );
};

/* ═══════════════════════════════════════════════
   STARFIELD CANVAS
   ═══════════════════════════════════════════════ */
const StarfieldCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const starsRef = useRef<any[]>([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const DPR = Math.min(2, window.devicePixelRatio || 1);
    let W = 0,
      H = 0;

    const resize = () => {
      W = canvas.width = Math.floor(window.innerWidth * DPR);
      H = canvas.height = Math.floor(window.innerHeight * DPR);
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
      makeStars();
    };

    const makeStars = () => {
      starsRef.current = [];
      for (let i = 0; i < 120; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          z: Math.random() + 0.2,
          r: Math.random() * 1.2 + 0.2,
          vx: (Math.random() * 0.25 + 0.05) * DPR,
          vy: 0,
          a: Math.random() * 0.6 + 0.2,
          isAmbient: false,
        });
      }
      for (let i = 0; i < 20; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          z: 0.1,
          r: Math.random() * 3 + 2,
          vx: (Math.random() * 0.1 - 0.05) * DPR,
          vy: -(Math.random() * 0.3 + 0.15) * DPR,
          a: Math.random() * 0.12 + 0.04,
          isAmbient: true,
          color: Math.random() > 0.5 ? "cyan" : "violet",
          pulsePhase: Math.random() * Math.PI * 2,
          pulseSpeed: Math.random() * 0.02 + 0.01,
        });
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      const g = ctx.createRadialGradient(W * 0.5, H * 0.5, 0, W * 0.5, H * 0.5, Math.max(W, H) * 0.55);
      g.addColorStop(0, "rgba(0,0,0,0)");
      g.addColorStop(1, "rgba(0,0,0,0.65)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      for (const s of starsRef.current) {
        if (s.isAmbient) {
          s.x += s.vx;
          s.y += s.vy;
          if (s.y < -20) {
            s.y = H + 20;
            s.x = Math.random() * W;
          }
          if (s.x < -20) s.x = W + 20;
          if (s.x > W + 20) s.x = -20;
          s.pulsePhase += s.pulseSpeed;
          const pa = s.a * (0.6 + 0.4 * Math.sin(s.pulsePhase));
          const bc = s.color === "cyan" ? "54,231,255" : "180,107,255";
          ctx.save();
          ctx.shadowBlur = 15;
          ctx.shadowColor = `rgba(${bc},${pa * 2})`;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${bc},${pa})`;
          ctx.fill();
          ctx.restore();
        } else {
          s.x += s.vx * s.z;
          if (s.x > W + 20) {
            s.x = -20;
            s.y = Math.random() * H;
          }
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,255,255,${s.a})`;
          ctx.fill();
          if (Math.random() < 0.015) {
            ctx.strokeStyle = `rgba(54,231,255,${s.a * 0.5})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(s.x, s.y);
            ctx.lineTo(s.x - 30 * DPR * s.z, s.y);
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(draw);
    };

    resize();
    window.addEventListener("resize", resize);
    draw();
    return () => window.removeEventListener("resize", resize);
  }, []);

  return <canvas ref={canvasRef} style={{ position: "fixed", inset: 0, width: "100%", height: "100%", zIndex: 0 }} />;
};

/* ═══════════════════════════════════════════════
   GAME CONTAINER
   ═══════════════════════════════════════════════ */
const GameContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <style>{gameStyles}</style>
    <div className="game-root">
      <StarfieldCanvas />
      <div className="scanlines"></div>
      <div className="wrap">{children}</div>
    </div>
  </>
);



const gameStyles = `
  :root{
    --bg0:#05060a;
    --glass: rgba(255,255,255,.06);
    --glass2: rgba(255,255,255,.10);
    --stroke: rgba(255,255,255,.14);
    --text: rgba(255,255,255,.92);
    --muted: rgba(255,255,255,.70);
    --good: #4CFFB0;
    --bad:  #FF4C7B;
    --cyan: #36E7FF;
    --violet:#B46BFF;
    --gold: #FFD36B;
    --shadow: 0 20px 60px rgba(0,0,0,.55);
    --radius: 18px;
  }

  .game-root {
    color: var(--text);
    background: radial-gradient(1200px 800px at 20% 10%, rgba(180,107,255,.15), transparent 55%),
                radial-gradient(900px 700px at 80% 30%, rgba(54,231,255,.14), transparent 55%),
                radial-gradient(900px 700px at 50% 90%, rgba(255,211,107,.10), transparent 55%),
                var(--bg0);
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    overflow: hidden;
  }

  *{box-sizing:border-box}

  .scanlines{
    pointer-events:none;
    position:fixed; inset:0;
    z-index:1;
    background: repeating-linear-gradient(to bottom, rgba(255,255,255,.03), rgba(255,255,255,.03) 1px, rgba(0,0,0,0) 3px, rgba(0,0,0,0) 6px);
    mix-blend-mode: overlay;
    opacity:.35;
    animation: scan 6s linear infinite;
  }
  @keyframes scan{ from{transform:translateY(-10px)} to{transform:translateY(10px)} }


    .wrap{
      min-height:63vh;
      height:120px;
      position:relative;
      z-index:2;
      display:grid;
      place-items:center;
      padding:24px;
      width:min(94vw, 70rem);
      // width:100%;
      max-height:85vh;
      overflow-y:auto;
      overflow-x:hidden;
      margin:0 auto;
      font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    }

  //  .card{
  //   // width:min(920px, 100%);
  //   width:100%;
  //   border-radius: var(--radius);
  //   background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  //   border:1px solid var(--stroke);
  //   box-shadow: var(--shadow);
  //   backdrop-filter: blur(14px);
  //   -webkit-backdrop-filter: blur(14px);
  //   overflow:hidden;
  //   position:relative;
  //   display:flex;
  //   flex-direction:column;
  //   flex: 0 0 auto;
  //   height: 385px;
  //   padding:1rem;
  //   margin: 0 auto; 
  // }
  .card {
  // width: fit-content;      /* 👈 key change */
  // max-width: 920px;        /* 👈 limit like your design */
  // min-width: 300px;        /* 👈 safety for small content */

  // width:100%;

  // margin: 0 auto;
  width:fit-content;
      // min-width:320px;
      // max-width:800px;
 width:100%;

  margin: 0 2px 0 0;
  
  border-radius: var(--radius);
  background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  border: 1px solid var(--stroke);
  box-shadow: var(--shadow);

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  padding: 1rem;
}
@media (min-resolution: 1.25dppx) {
  .card {
    zoom: 0.92;
  }
}
  //   .card{
  //   width:min(920px, 100%);
  //   border-radius: var(--radius);
  //   background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  //   border:1px solid var(--stroke);
  //   box-shadow: var(--shadow);
  //   backdrop-filter: blur(14px);
  //   overflow:hidden;
  //   position:relative;
  //   display: flex;
  //   flex-direction: column;
  //   max-height:390px;
  //   // min-height:500px;
  // }

  .card *{ box-sizing: border-box; }

  .card::before{
    content:"";
    position:absolute; inset:0;
    background: radial-gradient(600px 220px at 20% 0%, rgba(54,231,255,.18), transparent 60%),
                radial-gradient(420px 200px at 80% 10%, rgba(180,107,255,.16), transparent 60%);
    opacity:.9;
    pointer-events:none;
  }
.content {
  max-height: 500px;
  overflow-y: auto;
}
  .ranking-list::-webkit-scrollbar {
  width: 6px;
}

.ranking-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 6px;
}
  .card::after{
    content:"";
    position:absolute;
    inset:-2px;
    border-radius: calc(var(--radius) + 2px);
    background: conic-gradient(from 180deg, rgba(54,231,255,.20), rgba(180,107,255,.18), rgba(255,211,107,.10), rgba(54,231,255,.20));
    filter: blur(14px);
    opacity:.16;
    animation: aura 14s linear infinite;
    pointer-events:none;
    z-index:0;
  }
  @keyframes aura{ from{transform: rotate(0deg)} to{transform: rotate(360deg)} }

  .card > *{ position:relative; z-index:1; }

  .card.complete{
    border-color: rgba(54,231,255,.5);
    box-shadow: 0 0 60px rgba(54,231,255,.25), 0 0 120px rgba(180,107,255,.15);
  }

  .topbar{
    display:flex;
    align-items:center;
    gap:12px;
    padding:12px 16px 8px;
    border-bottom:1px solid rgba(255,255,255,.10);
    position:relative;
    z-index:1;
  }
  .title { 
  display:flex; 
  flex-direction:column;
  justify-content:start;
  align-items:start;
  gap:2px; 
  flex:1;
  min-width:0;
  }
  .title h1 { 
  margin:0; 
  font-size:15px; 
  letter-spacing:.2px; 
  }
  .title p { 
  margin:0; 
  font-size:12px; 
  color:var(--muted); 
  line-height:1.4; 
  overflow:hidden; 
  text-overflow:ellipsis; 
  white-space:nowrap;
  }

  .badge{
    display:inline-flex;
    align-items:center;
    gap:8px;
    padding:8px 10px;
    border-radius:12px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.18);
    color:rgba(255,255,255,.86);
    font-size:12px;
    box-shadow: 0 10px 24px rgba(0,0,0,.22);
    flex-shrink:0;
  }
  .dot{
    width:8px; height:8px; border-radius:50%;
    background: radial-gradient(circle at 30% 30%, #fff, rgba(255,255,255,.2));
    box-shadow: 0 0 14px rgba(54,231,255,.55);
  }
  .pts{
    display:inline-flex; align-items:baseline; gap:6px;
    font-size:13px; color:rgba(255,255,255,.86); letter-spacing:.2px;
    white-space:nowrap; font-variant-numeric: tabular-nums;
  }
  .pts b{ font-weight:700; color:rgba(255,255,255,.92); }

  /* Timer */
  .timer-ring { position: relative; width: 40px; height: 40px; flex-shrink: 0; }
  .timer-ring svg { transform: rotate(-90deg); width: 100%; height: 100%; }
  .timer-ring circle { fill: none; stroke-width: 3; }
  .timer-ring .timer-bg { stroke: rgba(255,255,255,.1); }
  .timer-ring .timer-progress { stroke: var(--cyan); stroke-linecap: round; transition: stroke-dashoffset 1s linear, stroke 0.3s ease; }
  .timer-ring.warning .timer-progress { stroke: var(--gold); }
  .timer-ring.danger .timer-progress { stroke: var(--bad); }
  .timer-text { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: var(--text); }

  .content{
    display:flex;
    flex-direction:column;
    gap:12px;
    padding:12px 16px 14px;
    position:relative;
    z-index:1;
    flex:1;
    min-height:0;
    overflow:hidden;
  }

  .chat{
    position:relative;
    display:flex;
    flex-direction:column;
    gap:6px;
    overflow-y: auto;
    overflow-x: hidden;
    flex:1;
    min-height: 0;
    background: linear-gradient(180deg, transparent, rgba(54,231,255,.02));
    scrollbar-gutter: stable;
  }
  .chat::after{
    content:'';
    position:absolute; top:0; left:0; right:0; height:60px;
    background: linear-gradient(180deg, rgba(54,231,255,.04), transparent);
    pointer-events:none;
  }

  /* Scrollbar */
  .chat::-webkit-scrollbar { width: 10px; }
  .chat::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .chat { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }

    /* Scrollbar */
  .wrap::-webkit-scrollbar { width: 10px; }
  .wrap::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .wrap { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }

  .elements-container{ display:flex; flex-direction:column; gap:6px; }
  .elements-row{
    display:flex; flex-wrap:wrap; align-items:center; gap:6px;
    padding:6px 10px;
    background: var(--glass);
    border:1px solid var(--stroke);
    border-radius:10px;
    min-height:42px;
    z-index:1;
    overflow:hidden;
  }

  .smart-chip{
    padding:6px 12px; font-size:12px; font-weight:600;
    background: linear-gradient(135deg, rgba(54,231,255,.12), rgba(180,107,255,.12));
    border:1px solid rgba(54,231,255,.35);
    border-radius:20px; color:var(--text); cursor:grab;
    transition: all .2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    user-select:none; position:relative; z-index:1;
  }
  .smart-chip:hover{
    background: linear-gradient(135deg, rgba(54,231,255,.22), rgba(180,107,255,.22));
    border-color: var(--cyan); transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(54,231,255,.18);
  }
  .smart-chip.dragging{
    opacity:1; cursor:grabbing; transform: scale(1.05);
    box-shadow: 0 12px 30px rgba(54,231,255,.35), 0 0 20px rgba(180,107,255,.25);
    z-index:100; border-color: var(--cyan);
    background: linear-gradient(135deg, rgba(54,231,255,.25), rgba(180,107,255,.25));
  }
  @keyframes chipReturn { 0% { transform: scale(0.8); opacity: 0.5; } 50% { transform: scale(1.1); } 100% { transform: scale(1); opacity: 1; } }
  .smart-chip.returning { animation: chipReturn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); }

  .goals-list{ display:flex; flex-direction:column; gap:3px; position:relative; z-index:1; flex-shrink:0; }
  .goal-wrapper{ display:flex; flex-direction:column; }

  .goal-row{
    display:flex; align-items:center; gap:8px; padding:6px 10px;
    background: var(--glass); border:1px solid var(--stroke);
    border-radius:10px; transition: all .3s ease; overflow:hidden;
  }
  .goal-row.drag-over{ border-color: var(--cyan); background: rgba(54,231,255,.08); }
  .goal-row.correct{ border-color: var(--good); box-shadow: 0 0 14px rgba(76,255,176,.12); }
  .goal-row.wrong{ animation: shake .4s ease; }
  @keyframes shake{ 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-5px)} 40%,80%{transform:translateX(5px)} }

  .goal-text
  { 
   flex:1; 
   font-size:13px;
   font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial; 
   color:var(--text);
   line-height:1.35; 
  }

  .drop-zone{
    min-width:90px; height:30px;
    display:flex; align-items:center; justify-content:center;
    padding:0 12px;
    background: rgba(54,231,255,.04);
    border:2px dashed rgba(54,231,255,.28);
    border-radius:18px; font-size:12px; color:var(--muted);
    transition: all .2s ease; cursor:pointer; flex-shrink:0;
  }
  .drop-zone:hover{ border-color: var(--cyan); background: rgba(54,231,255,.08); }
  @keyframes magnetPulse {
    0%, 100% { transform: scale(1); box-shadow: 0 0 12px rgba(54,231,255,.25); }
    50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(54,231,255,.45), 0 0 30px rgba(180,107,255,.25); }
  }
  .drop-zone.drag-over{ border-color: var(--cyan); background: rgba(54,231,255,.14); animation: magnetPulse 0.8s ease-in-out infinite; }
  @keyframes slotIn { 0% { transform: scale(0.8); opacity: 0.5; } 50% { transform: scale(1.1); } 100% { transform: scale(1); opacity: 1; } }
  .drop-zone.filled{
    background: linear-gradient(135deg, rgba(54,231,255,.16), rgba(180,107,255,.16));
    border:1px solid var(--cyan); color:var(--text); font-weight:600; font-size:13px;
  }
  .drop-zone.slot-in{ animation: slotIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }

  .correct-indicator{
    display:none; width:22px; height:22px;
    background: var(--good); border-radius:50%;
    align-items:center; justify-content:center;
    font-size:12px; color:#000; flex-shrink:0; font-weight:700;
  }
  .goal-row.correct .correct-indicator{ display:flex; }

  .hint{ display:none; font-size:12px; margin-top:4px; padding-left:4px; }
  .hint.wrong { color: var(--gold); display:block; }
  .hint.correct { color: var(--good); display:block; }

  .submit-btn{
    display:none;
    margin-left:auto;
    padding:10px 20px; font-size:13px; font-weight:600;
    background: linear-gradient(135deg, rgba(255,211,107,.2), rgba(255,140,0,.2));
    border:1px solid rgba(255,211,107,.5);
    border-radius:20px; color:var(--text); cursor:pointer;
    transition: all .3s ease; white-space:nowrap;
  }
  .submit-btn.show{ display:flex; align-items:center; }
  .submit-btn:hover{
    background: linear-gradient(135deg, rgba(255,211,107,.35), rgba(255,140,0,.35));
    border-color: rgba(255,211,107,.7); transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255,211,107,.3);
  }

  /* Ranking mode overrides */
  .ranking-list{ 
  max-height: 400px;   /* adjust height as needed */
  overflow-y: auto;
  overflow-x: hidden;
   display:flex; 
   flex-direction:column; 
   gap:5px;
    }
  .ranking-item{
    display:flex; align-items:center; gap:8px; padding:8px 10px;
    background: var(--glass); border:1px solid var(--stroke);
    border-radius:12px; transition: all .3s ease;
    cursor:grab; user-select:none;
  }
  .ranking-item:hover{ background: var(--glass2); border-color: rgba(54,231,255,.3); }
  .ranking-item.dragging{
    opacity:0.9; cursor:grabbing; transform: scale(1.02);
    box-shadow: 0 12px 30px rgba(54,231,255,.25);
    border-color: var(--cyan);
    background: linear-gradient(135deg, rgba(54,231,255,.12), rgba(180,107,255,.12));
    z-index:100;
  }
  .ranking-item.drag-over{ border-color: var(--cyan); background: rgba(54,231,255,.08); }
  .ranking-item.selected{
    border-color: var(--cyan);
    background: linear-gradient(135deg, rgba(54,231,255,.10), rgba(180,107,255,.10));
    box-shadow: 0 0 20px rgba(54,231,255,.15);
  }
  .ranking-item.correct{ border-color: var(--good); background: rgba(76,255,176,.08); }
  .ranking-item.wrong{ border-color: var(--bad); background: rgba(255,76,123,.08); animation: shake .4s ease; }

  .drag-handle{ display:flex; flex-direction:column; gap:2px; padding:4px; color:var(--muted); }
  .drag-handle span{ display:block; width:14px; height:2px; background:currentColor; border-radius:1px; }

  .select-indicator{
    width:14px; height:14px; border-radius:3px;
    border:2px solid rgba(255,255,255,.3);
    display:flex; align-items:center; justify-content:center;
    flex-shrink:0; transition: all .2s ease; cursor:pointer;
  }
  .ranking-item:hover:not(.selected) .select-indicator{ border-color: var(--cyan); background: rgba(54,231,255,.1); }
  .ranking-item.selected .select-indicator{ border-color: var(--cyan); background: var(--cyan); }
  .ranking-item.selected .select-indicator::after{ content:'✓'; font-size:10px; color:#000; }

  .rank-badge{
    min-width:28px; height:28px; display:none;
    align-items:center; justify-content:center;
    background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
    border:1px solid rgba(54,231,255,.3); border-radius:8px;
    font-size:12px; font-weight:700; color:var(--text); flex-shrink:0;
  }
  .ranking-item.selected .rank-badge{ display:flex; }

  .item-text{ flex:1; font-size:13px; color:var(--text); line-height:1.4; }

  .result-indicator{
    display:none; width:24px; height:24px; border-radius:50%;
    align-items:center; justify-content:center; font-size:14px; flex-shrink:0;
  }
  .ranking-item.correct .result-indicator,
  .ranking-item.wrong .result-indicator{ display:flex; }

  .hint-text{ display:none; font-size:12px; color:var(--gold); margin-top:6px; padding-left:52px; }
  .hint-text.show{ display:block; }

  .feedback-badge-container{ display:flex; align-items:center; margin-left:auto; flex-shrink:0; }
  .feedback-badge{ padding:4px 10px; border-radius:6px; font-size:11px; font-weight:600; white-space:nowrap; }
  .feedback-badge.wrong-choice{ background:rgba(255,76,123,.15); border:1px solid var(--bad); color:var(--bad); }
  .feedback-badge.wrong-order{ background:rgba(255,211,107,.15); border:1px solid var(--gold); color:var(--gold); }

  .footer{
    display:flex; justify-content:flex-end; align-items:center; gap:10px;
    padding:10px 14px; border-top:1px solid rgba(255,255,255,.08);
  }
  .footer .submit-btn{ display:flex; align-items:center;
    background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
    border:1px solid rgba(54,231,255,.4);
  }
  .footer .submit-btn:hover{
    background: linear-gradient(135deg, rgba(54,231,255,.25), rgba(180,107,255,.25));
    border-color: rgba(54,231,255,.6);
  }
  .footer-hint{ flex:1; font-size:11px; color:var(--muted); opacity:0.7; }
  .reset-btn{
    display:flex; align-items:center; padding:10px 16px;
    font-size:13px; font-weight:600; background: transparent;
    border:1px solid rgba(255,255,255,.2); border-radius:20px;
    color:var(--muted); cursor:pointer; transition: all .3s ease;
  }
  .reset-btn:hover{ border-color: rgba(255,255,255,.4); color:var(--text); }

  /* Completion overlay */
  .completion-overlay{
    display:none; position:absolute; inset:0; z-index:100;
    background: linear-gradient(135deg, rgba(5,6,10,.97), rgba(10,15,30,.97));
    backdrop-filter: blur(8px); border-radius: var(--radius);
    overflow: hidden;
  }
  .completion-overlay.show{ display:grid; place-items:center; animation: scaleIn 0.4s ease-out; }
  .completion-content {
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; padding: 16px 22px 26px; gap: 6px; flex: 0 0 auto;
  }
  .completion-overlay::-webkit-scrollbar { width: 10px; }
  .completion-overlay::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .completion-overlay::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .completion-overlay { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }

  @keyframes scaleIn{ from{opacity:0; transform: scale(0.9);} to{opacity:1; transform: scale(1);} }

  .completion-emoji{ font-size:56px; animation: bounce 0.6s ease; margin-bottom:1rem; }
  @keyframes bounce{ 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }

  .completion-title{ font-size:24px; font-weight:700; color:var(--text); margin:0; }
  .completion-subtitle{ font-size:14px; color:rgba(255,255,255,.7); margin:0 0 10px; }
  .completion-score{
    font-size:36px; 
    line-height:1.5;
    font-weight:800;
    background: linear-gradient(135deg, #FFD700, #FFA500, #FF8C00);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 25px rgba(255,215,0,.6));
    animation: pulse 2s ease-in-out infinite;
  }
  @keyframes pulse{ 0%,100%{transform:scale(1)} 50%{transform:scale(1.05)} }

  .completion-message{
    font-size:14px; color:var(--muted); max-width:360px; line-height:1.4;
    margin:0; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;
  }
  .replay-btn{
    margin-top:12px; padding:14px 28px; font-size:15px; font-weight:600;
    background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
    border:1px solid rgba(54,231,255,.5); border-radius:12px;
    color:var(--text); cursor:pointer; transition: all .2s ease;
    position: relative;
    z-index: 50;
    opacity: 1 !important;
    transform: none !important;
  }
  .replay-btn:hover{
    background: linear-gradient(135deg, rgba(54,231,255,.25), rgba(180,107,255,.25));
    transform: translateY(-2px); box-shadow: 0 4px 20px rgba(54,231,255,.3);
  }
  .next-instruction{ margin-top:12px; font-size:13px; color:var(--muted); padding-bottom:14px; margin-bottom:2px; }
  .next-instruction b{ color:var(--text); }

  /* Streak popups */
  .streak-popup{
    position:absolute; top:50%; left:50%;
    transform: translate(-50%, -50%) scale(0);
    padding:8px 16px; border-radius:20px; font-size:14px; font-weight:700;
    color:#fff; pointer-events:none; z-index:50; white-space:nowrap;
    animation: streakPop 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  .streak-popup.nice{ background: linear-gradient(135deg, var(--cyan), var(--violet)); box-shadow: 0 4px 20px rgba(54,231,255,.4); }
  .streak-popup.wow{ background: linear-gradient(135deg, var(--violet), #FF6BCD); box-shadow: 0 4px 20px rgba(180,107,255,.5); }
  .streak-popup.perfect{ background: linear-gradient(135deg, var(--gold), #FF8C00); box-shadow: 0 4px 25px rgba(255,211,107,.6); }
  @keyframes streakPop{
    0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
    20% { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
    40% { transform: translate(-50%, -50%) scale(1); }
    80% { transform: translate(-50%, -80%) scale(1); opacity: 1; }
    100% { transform: translate(-50%, -100%) scale(0.8); opacity: 0; }
  }

  .particle-container{
    position:fixed; inset:0; pointer-events:none; z-index:99; overflow:hidden;
  }
  .particle{
    position:absolute; width:6px; height:6px; border-radius:50%;
    pointer-events:none; animation: particleFade 0.6s ease-out forwards;
  }
  @keyframes particleFade{ 0% { transform: scale(1); opacity: 0.8; } 100% { transform: scale(0); opacity: 0; } }

  /* Time's Up Overlay */
  .timeup-overlay {
    position: absolute; inset: 0; z-index: 100; display: none;
    place-items: center; background: rgba(5,6,10,.85); padding: 18px; border-radius: var(--radius);
  }
  @supports (backdrop-filter: blur(10px)) {
    .timeup-overlay { background: rgba(0,0,0,.55); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); }
  }
  .timeup-overlay.show { display: grid; animation: fadeIn 0.3s; }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  .timeup-dialog {
    width: min(560px, 100%); border-radius: 16px;
    border: 1px solid rgba(255,76,123,.26); background: rgba(20,22,35,.92);
    padding: 14px; box-shadow: 0 22px 80px rgba(0,0,0,.65), 0 0 0 1px rgba(255,76,123,.08) inset;
    animation: pop 0.18s ease-out; position: relative;
  }
  .timeup-dialog::before {
    content: ""; position: absolute; inset: 0; border-radius: 16px; pointer-events: none;
    background: radial-gradient(520px 220px at 15% 0%, rgba(54,231,255,.14), transparent 60%),
      radial-gradient(420px 200px at 85% 10%, rgba(180,107,255,.12), transparent 60%);
    opacity: 0.9;
  }
  .timeup-dialog > * { position: relative; z-index: 1; }
  @keyframes pop { from { transform: scale(.98); opacity: 0; } to { transform: scale(1); opacity: 1; } }
  .timeup-head { display: flex; align-items: center; gap: 12px; margin-bottom: 6px; }
  .timeup-head strong { font-size: 13px; letter-spacing: 0.2px; color: var(--text); }
  .timeup-text { margin: 0 0 8px; font-size: 13px; color: rgba(255,255,255,.84); line-height: 1.45; }
  .timeup-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 12px; }
  .ghost {
    border: 1px solid rgba(255,255,255,.16); background: rgba(255,255,255,.06);
    color: rgba(255,255,255,.86); padding: 10px 12px; border-radius: 14px;
    cursor: pointer; font-size: 13px; font-weight: 500;
    transition: transform 0.12s ease, filter 0.12s ease;
  }
  .ghost:hover { transform: translateY(-1px); filter: drop-shadow(0 0 16px rgba(54,231,255,.10)); }
  .ghost:active { transform: translateY(0) scale(.99); }

  .locked-toast {
    position: fixed; bottom: 24px; left: 50%;
    transform: translateX(-50%) translateY(100px);
    background: rgba(0,0,0,.85); border: 1px solid rgba(255,211,107,.4);
    border-radius: 12px; padding: 12px 24px; color: var(--gold);
    font-size: 14px; font-weight: 500; z-index: 200; opacity: 0;
    transition: all 0.3s ease; pointer-events: none;
  }
  .locked-toast.show { transform: translateX(-50%) translateY(0); opacity: 1; }

  .scroll-indicator {
    position: absolute; bottom: 0; left: 0; right: 0; height: 40px;
    background: linear-gradient(to top, rgba(54,231,255,.15), transparent);
    pointer-events: none; opacity: 0; transition: opacity 0.3s ease;
    border-radius: 0 0 var(--radius) var(--radius); z-index: 5;
  }
  .scroll-indicator.show { opacity: 1; animation: scrollPulse 2s ease-in-out infinite; }
  @keyframes scrollPulse { 0%, 100% { opacity: 0.6; } 50% { opacity: 1; } }
  .scroll-indicator::after {
    content: '↓ Scroll for more'; position: absolute; bottom: 8px; left: 50%;
    transform: translateX(-50%); font-size: 11px; color: var(--cyan); white-space: nowrap;
  }

  .feedback-popup {
    position: absolute; top: -8px; right: 60px; padding: 6px 12px;
    border-radius: 8px; font-size: 12px; font-weight: 600; color: #fff;
    pointer-events: none; z-index: 50; white-space: nowrap;
    animation: feedbackPop 1.5s ease-out forwards;
  }
  .feedback-popup.correct { background: linear-gradient(135deg, var(--good), #2da67a); box-shadow: 0 4px 16px rgba(76,255,176,.35); }
  @keyframes feedbackPop {
    0% { opacity: 0; transform: translateY(10px) scale(0.8); }
    15% { opacity: 1; transform: translateY(0) scale(1); }
    85% { opacity: 1; transform: translateY(0) scale(1); }
    100% { opacity: 0; transform: translateY(-10px) scale(0.9); }
  }

  @media (max-width:640px){
    .topbar{flex-direction:column; gap:10px;}
    .goal-row{flex-direction:column; align-items:stretch; gap:8px;}
    .drop-zone{width:100%;}
  }
  @media (max-width: 600px) {
    .wrap { padding: 12px; }
    .ranking-item { padding: 8px 10px; }
    .item-text { font-size: 12px; }
    .rank-badge { min-width: 24px; height: 24px; font-size: 11px; }
  }
`;

export default MatchRankPreview;
















